import * as Sentry from '@sentry/react';
import React, { Activity, useEffect, useMemo, useRef, useState } from "react";
import { useCollectionActivity } from 'utils/methods/firebaseActivity';
import { useDispatch } from "react-redux";
import { Autocomplete, FormLabel, Radio, RadioGroup } from '@mui/material';
import OnestudyModals from "components/OneStudy/OneStudyModal";
import OnegameModals from 'components/OneGame/OneGameModal';
import AdminSlides from 'modules/adminSlides';
import { Alert } from '@mui/material';
import AssignmentForm from "components/AdminBooks/AssignmentForm";
import AssignmentBuilderTool from 'components/AssignmentBuilder/AssignmentBuilderTool';
import BingoModal from 'modules/bingoModule';
import COLOR from "utils/constants/color";
import Cogantes from 'components/ebook/cogantes';
import CognateAiLoader from 'components/ebook/cogantes/cognateAiModal';
import ExtraResourceAdmin from 'modules/extraResource/admin';
import Loading from "components/Loading";
import { Snackbar } from '@mui/material';
import TextArea from "antd/lib/input/TextArea";
import TextReader from 'components/Reader';
import ToolBarSentenceStarterButton from 'modules/sentenceStarter/admin/toolBarButton';
import { filter, get, map, sortBy, find, uniqBy, findIndex, cloneDeep } from "lodash";
import { assignmentDraftHasUserContent } from 'features/forms/assignment/studentMatchMaking/helper';
import styled from "styled-components";
import { Col, Dropdown, Input as InputArea, Row, Modal as ConfirmModal, Tooltip, message } from "antd";
import { DeleteModal } from "components/Dialog";
import { EnterOutlined, InfoCircleOutlined, EditOutlined } from '@ant-design/icons';
import { handleCreateVocabulary, handleCreateVocabularyAI, handleDeleteVocabulary, handleGenerateVocabularyWithMode, setDataVocabular } from "store/vocabulary/thunks";
import { handleCreatePhrases, handleDeletePhrases, setDataPhrases, handleListPhrases, handleGeneratePhrasesWithAI, handleGeneratePhrasesWithMode } from "store/Phrases/thunks";
import { handleStreamResponseForCognates } from 'utils/methods/CognatesStreamHandler';
import { createVocabularySuccessCogantes } from 'store/cogantes/actions';
import { mapBookByOrderCreateUser, sortByCustomType } from 'utils/lib/ebookHelper';
import { useApExams } from 'store/apexams/selectors';
import { useAudio } from 'utils/context/AudioProvider';
import { useAllBook, useBookOrder } from 'store/books/selectors';
import { useCognets } from 'store/cogantes/selectors';
import { useCurrentClass } from "store/classes/selectors";
import { useCurrentUser } from "store/users/selectors";
import { useExams } from 'store/exams/selectors';
import { useStory } from 'store/story/selectors';
import { useVocabulary } from "store/vocabulary/selectors";
import { usePhrases } from "store/Phrases/selectors";
import { useHasPermission } from 'utils/permissions';
import AdminActivity from './adminActivity';
import BadgeButton from './BadgeButton';
import GrammarContentToolBar from './PageToolbarModals/GrammarContentTool';
import GraphicOrganizerAdmin from './PageToolbarModals/GraphicOrganizer';
import PageTranslationToolbar from './PageToolbarModals/PageTranslationTool';
import VocabContentToolBar from './PageToolbarModals/VocabAiTool';
import { AnswerModal, ArticleLevelToolBar, HyperLinkForm, IntrectionModal, LessonPlanModal, PacingSyallabus, PageImagePickerTeacher, SubTopicUnits, Syallabus, TipsModal, PDFUploader } from "./PageToolbarModals/index";
import GenerateMaskModal from "./PageToolbarModals/GenerateMaskModal";
import {
  Button,
  FormControl,
  FormHelperText,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  TextareaAutosize,
  
  Chip,
  Typography,
  FormControlLabel,
  Switch
} from '@mui/material';
import { makeStyles } from '@mui/styles';

import {
  Add,
  Close,
  Delete,
  MenuBook,
  QuestionAnswer,
  Link,
  Star,
  Tune,
  Quiz,
  Grading,
  Book,
  LibraryBooks,
  InsertLink,
  Assessment,
  Lightbulb,
  TouchApp,
  Assignment,
  Spellcheck,
  AssignmentOutlined
} from '@mui/icons-material';
import { useFirebase } from 'containers/FirebaseContext';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import TeacherEditionModal from '../../modules/teacherEdition/admin/teacherEditionModal';
import ToolBarEngageMentAdmin from 'modules/engageFeature/admin';
import useBookCollection from 'components/hooks/books/useBookCollection';
import { useStandardExams } from 'store/standardexams';
import { useAdminActivityLogger } from 'components/hooks/useAdminActivityLogger';
import SoyHistoriasAdmin from 'modules/soyHistoriasAdmin/SoyHistoriasAdmin';
import SentryWrap from 'components/Sentry';

const Wrapper = styled.div`
  height: 100%;
  min-height: 600px;
  width: 100%;

  position: relative;
`;

const Toolbar = styled.div`
  align-items: center;
  border-bottom: 1px solid ${COLOR.black600};
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  padding-bottom: 4px;
  width: 100%;
  min-height: 30px;
  margin-top: 30px;
`;

const TestGenerator = styled.button`
  width: 100%;
  max-width: 100%;
  height: auto;
  min-height: 35.16px;
  max-height: 35.16px;
  border-radius: 18px;
  background: #002d75;
  cursor: pointer;
  color: white;
  flex: 1 1 0%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2px;
`;

const ModalContent = styled.div`
   left: 50%;
   max-width: 100vw;
   min-width: 450px;
   padding: 0px 24px;
   position: absolute;
   border-radius: 10px;
   background-color: #fff;
   padding: 10px;
   transform: translate(-50%, -50%);
   top: 50%; 
   @media (max-width: 1366px) {
     width: 90vw;
   }
 
   @media (max-width: 500px) {
     max-height: 560px;
  }
`;
const ModalFullContent = styled.div`
  left: 50%;
  width:80vw; 
  max-height:90vh;
  padding: 0px 24px;
  position: absolute;
  min-height: 350px;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 20px; 
    @media only screen and (max-width: 600px) {
        min-width: 90% !important;
    }
`;
const ModalContents = styled.div`
  left: 50%;
  max-width: 544px;
  min-width: 450px;
  padding: 0px 24px;
  position: absolute;
  border-radius: 10px;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 10px;
  width: ${(p) => p.is_non_spanish ? "100% !important" : "93% !important"};
  max-width: ${(p) => p.is_non_spanish ? "95vw !important" : ""}  
`;
const ModalConfigArea = styled.div`
  max-height: 75vh;
  overflow: auto;
  margin-top: 10px;
  overflow-y: scroll;
  overflow-x: hidden;
`;
const Page = styled.div`
  align-items: center;
  color: ${COLOR.black100};
  display: flex;
  flex-direction: row;
  font-size: 14px;
  font-weight: 400;
  white-space: nowrap;
`;

const Input = styled.input`
  background-color: transparent;
  border: 1px dashed gray;
  border-radius: 3px;
  box-shadow: none;
  font-size: inherit;
  font-weight: 600;
  outline: none;
  padding: 0px 2px;
  transition: all 300ms ease;
  width: 80px;
`;

const LinkArea = styled.div`
  padding: 10px;
  margin: 2px;
  border: 1px dashed;
  margin-top: 24px;
`;

const AssignmemntArea = styled.div`
  margin-top: 16px;
`;

const TextAreaAuto = styled(TextareaAutosize)`
    height: 200px;
    width: 100%;
    border-radius: 2px;
    padding: 5px;
    overflow: hidden;
    border-color: rgb(0 0 0 / 32%);
    ::focus-visible {
      outline: ${COLOR.green100}auto 1px !important;
     }
    ::focus{
      border-color: ${COLOR.green100} !important;
  }
`;
const TitleText = styled.span`
    font-size: 18px;
    color: black;
    font-weight:600;
    // margin-left:5px;
    // margin-top:5px;
`;


const ActionText = styled.p`
font-size:14px;
color:white;
font-weight:500;
`;

const CustomMenuItem = styled.div`
background: #f5a623; /* Distinct color for the menu item */
color: white; /* White text for contrast */
padding: 10px 20px; /* Spacing for readability */
border-radius: 5px; /* Rounded corners for a soft look */
margin: 5px; /* Spacing between menu items */
text-align: right; /* Align text to the right */
cursor: pointer;

&:hover {
background: #e0911e; /* Change color on hover */
}
`;
const CustomMenuItem2 = styled.div`
background: rgb(16,44,110); /* Distinct color for the menu item */
color: white; /* White text for contrast */
padding: 10px 20px; /* Spacing for readability */
border-radius: 5px; /* Rounded corners for a soft look */
margin: 5px; /* Spacing between menu items */
text-align: right; /* Align text to the right */
cursor: pointer;

&:hover {
background: rgb(16,44,110); /* Change color on hover */
}
`;

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: '4px',
  },
  rootDifFull: {
    width: "100%",
    cursor: 'default !important'
  },
  label: {
    textTransform: 'uppercase',
  },
  sizeSmall: {
    width: '55px',
    height: '25px'
  },
  checkedSwitch: {
    transform: 'translateX(30px) !important'
  },
}));

function filterOrdersByOrderIds(oneArray, orderIds) {
  const filteredOrders = [];
  for (const orderItem of oneArray) {
    if (
      orderItem.order?.some((itemId) => orderIds === itemId)
    ) {
      filteredOrders.push(orderItem);
    }
  }

  return filteredOrders;
}
const GameAiForm = ({ ai_content, pageId, onChangeGameAiContent, pages }) => {
  const [ai_content_data, set_ai_content_data] = useState({
    content: '',
    page_id: pageId,
    start_page: pageId,
    end_page: ''
  });
  const [content, setContent] = useState('');
  const [start_page, setStartPage] = useState('');
  const [end_page, setEndPage] = useState('');
  const [error, setError] = useState({
    start_page:'',
    end_page:'',
    content: ''
  });
  const classes = useStyles();

  useEffect(() => {
    if (ai_content && ai_content.length > 0) {
      const has_ai_content = find(ai_content, k => parseInt(k.start_page) <= parseInt(pageId) && parseInt(k.end_page) >= parseInt(pageId))
      if (has_ai_content) {
        set_ai_content_data(has_ai_content)
        setContent(has_ai_content.content);
        setStartPage(has_ai_content.start_page);
        setEndPage(has_ai_content.end_page);
      } else {
        set_ai_content_data({
          content: '',
          page_id: pageId,
          start_page: pageId,
          end_page: ''
        })
        setContent('');
        setStartPage(pageId);
        setEndPage(null);
      }
    } else {
      set_ai_content_data({
        content: '',
        page_id: pageId,
        start_page: pageId,
        end_page: ''
      })
      setContent('');
      setStartPage(pageId);
      setEndPage(null);
    }
    setError({
      start_page:'',
      end_page:'',
      content: ''
    })
  }, [ai_content, pageId]);

  const onUpdate = () => {
    if (validateError()) {
      const has_ai_content_index = findIndex(ai_content, k => k.page_id === ai_content_data.page_id)
      if (has_ai_content_index >= 0) {
        const dt = cloneDeep(ai_content)
        dt[has_ai_content_index] = {
          content,
          page_id: pageId,
          start_page,
          end_page
        }
        onChangeGameAiContent(dt)
      } else {
        const dt = cloneDeep(ai_content)
        dt.push({
          content,
          page_id: pageId,
          start_page,
          end_page
        })
        onChangeGameAiContent(dt)
      }
    }
  };
  const validateError = () => {
    setError({
      start_page:'',
      end_page:'',
      content: ''
    });
    if (start_page) {
      const has_alredy_taken = find(ai_content, k => parseInt(k.start_page) <= parseInt(start_page) && parseInt(k.end_page) >= parseInt(start_page))
      if (has_alredy_taken) {
        if (has_alredy_taken.page_id != ai_content_data.page_id) {
          setError({
            ...error,
           start_page: `Ai contet alredy set for ${start_page}`
          })
          return false;
        }
      }else if(start_page>end_page&&end_page) {
        setError({
          ...error,
         start_page: `Start page must be before end page.`
        })
        return false;
      }
    } else {
      setError({
        ...error,
       start_page: `Please set start page id.`
      })
      return false;
    }
    if (end_page) {
      const has_alredy_taken = find(ai_content, k => parseInt(k.start_page) <= parseInt(end_page) && parseInt(k.end_page) >= parseInt(end_page))
      if (has_alredy_taken) {
        if (has_alredy_taken.page_id != ai_content_data.page_id) {
          setError({
            ...error,
           end_page: `Ai contet alredy set for ${end_page}.`
          })
          return false;
        }
      }
    } else {
      setError({
        ...error,
       end_page: `Please set finish page id.`
      })
      return false;
    }
    if (!content) {
      setError({
        ...error,
       content: `Please set content.`
      })
      return false;
    }
    return true;
  }
  const onBlur = () =>{
    setError({
      start_page:'',
      end_page:'',
      content: ''
    });
  }
  return (
    <div>
      <ModalConfigArea style={{ overflow: "hidden" }}>
        <Row gutter={[24, 24]} style={{ marginTop: 20 }}>
          <Col span={12}>
            <TextField
              id="start_page_id"
              name="Start page id"
              label="Start page id"
              placeholder="Start page id"
              InputLabelProps={{ shrink: true }}
              type="text"
              variant="outlined"
              onBlur={onBlur}
              onChange={(e) => {
                setStartPage(e.target.value)
                // onChangeData("start_page", e.target.value)
              }}
              value={start_page}
            />
            {error.start_page ? (
              <FormHelperText error>
                {error.start_page}
              </FormHelperText>
            ) : null}
          </Col>
          <Col span={12}>
            <TextField
              id="end_page_id"
              name="End page id"
              label="End page id"
              placeholder="Finish page id"
              onBlur={onBlur}
              InputLabelProps={{ shrink: true }}
              type="text"
              variant="outlined"
              onChange={(e) => {
                setEndPage(e.target.value)
                // onChangeData("end_page", e.target.value)
              }}
              value={end_page}
            />
            {error.end_page ? (
              <FormHelperText error>
                {error.end_page}
              </FormHelperText>
            ) : null}
          </Col>

        </Row>
        <Row gutter={[24, 24]} style={{ marginTop: 20 }}>
          <Col span={24}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="textTip" style={{ backgroundColor: "#fff", paddingLeft: 2, paddingRight: 2 }}>Tip Text</InputLabel>
              <TextAreaAuto
                id="ai_content"
                type="text"
                minRows={3}
                onBlur={onBlur}
                maxRows={5}
                variant="outlined"
                onChange={(e) => {
                  setContent(e.target.value)
                  // onChangeData("content", e.target.value)
                }}
                style={{ height:"60vh"}}
                value={content}
              />
            </FormControl>
          </Col>
        </Row>
      </ModalConfigArea>
      {error.content ? (
        <FormHelperText error>
          {error.content}
        </FormHelperText>
      ) : null}
     
      <Row
        gutter={[24, 24]}
        style={{ marginTop: 16, marginRight: 0, marginLeft: 0 }}
      >
        <Button
          fullWidth
          disabled={error.start_page || error.content || error.end_page}
          onClick={onUpdate}
          color="primary"
          variant="contained"
        >
          Update
        </Button>
      </Row>
    </div>
  );
};
const AssignmentPlanModal = ({ planData, booksAllList, close, pageId, onRemoveAssignmentPlan, updatePlan, type, bookId, totalPages = 0, pages: currentBookPages = [] }) => {
  const [plan, setPlan] = useState(null)
  const bookOrder = useBookOrder()
  const [deleteModal, setDeleteModal] = useState(false)
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [selectedLinkBook, setSelectedLinkBook] = useState([]);
  const classes = useStyles();
  const orderedBook = mapBookByOrderCreateUser(booksAllList, filterOrdersByOrderIds(bookOrder, bookId))[0];
  useEffect(() => {
    if (planData) {
      if(type === "Lesson" && !planData?.levelTitle){
        planData.levelTitle = 'Lesson Plan';
      }
      setPlan(planData);
      const linkBookPages = booksAllList.find((bk) => bk.id === get(planData, "resourceId") || bk.id === bookId)?.pages;
      setSelectedLinkBook(linkBookPages);
    } else {
      setPlan({
        page: pageId,
        from: '',
        to: '',
        resourceId: '',
        ...(type === "Lesson" && { levelTitle: 'Lesson Plan'})
       
      });
      if(bookId){
        const linkBookPages = booksAllList.find((bk) => bk.id === bookId)?.pages;
        setSelectedLinkBook(linkBookPages);
      }
    }
  }, [planData,bookId,booksAllList])

  const onUpdate = () => {
    if (type === 'Assessment book link') {
      if (!plan?.from || !plan?.resourceId || !Array.isArray(selectedLinkBook)) {
        setError(true);
        setErrorMsg("All fields are required.");
        return;
      }
      const fromIndex = selectedLinkBook.findIndex(page => page.pageId == plan.from);
      if (fromIndex === -1) {
        setError(true);
        setErrorMsg("Please select valid pages.");
        return;
      }
      updatePlan(plan);
      return;
    }

    if (!plan?.from || !plan?.to || !Array.isArray(selectedLinkBook)) {
      setError(true);
      setErrorMsg("All fields are required.");
      return;
    }

    const fromIndex = selectedLinkBook.findIndex(page => page.pageId == plan.from);
    const toIndex = selectedLinkBook.findIndex(page => page.pageId == plan.to);

    if (fromIndex === -1 || toIndex === -1) {
      setError(true);
      setErrorMsg("Please select valid pages.");
      return;
    }

    if (fromIndex >= toIndex) {
      setError(true);
      setErrorMsg("From page must come before To page in the book.");
      return;
    }

    if (type === 'Super Lesson' || type === 'Differentiation') {
      const pageCount = toIndex - fromIndex + 1;
      if (pageCount > 10) {
        setError(true);
        setErrorMsg("AI can't generate more than 10 pages.");
        return;
      }
    }

    updatePlan(plan);
  }

  const disableBtn = () => {
    if (type === 'Super Lesson' || type === 'Differentiation') {
      return !Boolean(plan) || !plan.from || !plan.to
    } else if (type === 'Assessment book link') {
      return !Boolean(plan) || !plan.from || !plan.resourceId
    } else {
      return !Boolean(plan) || !plan.from || !plan.resourceId || !plan.to
    }
  }

  const booksAllListAssignment = filter(orderedBook?.books, (book) => {
    const hasPagesWithOnlyOneResourceNull = book.pages?.length <= 1 && !book?.pages[0]?.resource;
    return !book.onlyTeacher && book.id !== bookId && !hasPagesWithOnlyOneResourceNull && book?.markAsMainBook;
  });

  const dropdownPages = useMemo(() => {
    if (type === 'Assessment book link') return [];
    if (selectedLinkBook && Array.isArray(selectedLinkBook) && selectedLinkBook.length > 0) {
      return selectedLinkBook.map((page) => ({
        ...page,
        NumberMasked: page.NumberMasked || `Page ${page.pageId}`,
        pageId: parseInt(page.pageId)
      }));
    }
    if (!plan?.resourceId) {
      if (currentBookPages && Array.isArray(currentBookPages) && currentBookPages.length > 0) {
        return currentBookPages.map((page) => ({
          ...page,
          NumberMasked: page.NumberMasked || `Page ${page.pageId}`,
          pageId: parseInt(page.pageId)
        }));
      }
      return [];
    }
    const selectedBook = booksAllList.find((book) => book.id == plan.resourceId);
    if (selectedBook && selectedBook.pages && Array.isArray(selectedBook.pages)) {
      return selectedBook.pages.map((page) => ({
        ...page,
        NumberMasked: page.NumberMasked || `Page ${page.pageId}`,
        pageId: parseInt(page.pageId)
      }));
    }
    return [];
  }, [plan?.resourceId, booksAllList, type, selectedLinkBook, currentBookPages]);

  const handleOnChangeLevelTitle = (e) => {
      if(e.target && e.target.value){
        setPlan((prev) => ({
          ...prev,
          levelTitle: e.target.value
        }))
      }
  }


  return (<ModalContent>
    <DeleteModal deleteToggle={deleteModal} onDelete={() => {
      onRemoveAssignmentPlan(pageId)
      setDeleteModal(false)
    }}
      setDeleteToggle={setDeleteModal}
      message={`Are you sure you want to remove the ${type} plan on pageId ${pageId}?`} />
    <Row style={{ justifyContent: "space-between" }}>
      <TitleText>{type}</TitleText>
      <IconButton
        onClick={close}
        style={{ padding: 0 }}
      >
        <Close color="secondary" />
      </IconButton>
    </Row>
    <ModalConfigArea>
      <LinkArea>
        <Row
          gutter={[24, 24]}
          style={{ justifyContent: "space-between", display: "flex", alignItems:"center", paddingLeft: "10px" }}
        >
          {totalPages &&
          <FormHelperText style={{width:"400px"}}>
            Total Pages: {totalPages}
        </FormHelperText>
      }
          {planData ? <IconButton
            onClick={() => setDeleteModal(true)}
            style={{ padding: 0, marginRight: 10 }}
          >
            <Delete color="secondary" />
          </IconButton> : null}
        </Row>
        {type === "Lesson" && (
           <Row gutter={[24, 24]} style={{ marginTop: 10 }}>
              <Col span={24}>
                    <TextField
                      id="levelTitle"
                      name="levelTitle"
                      label="Level Title*"
                      InputLabelProps={{ shrink: true, required: true }}
                      type="text"
                      variant="outlined"
                      inputProps={{ maxLength: 30 }}
                      onChange={(e) => {
                        setPlan({
                          ...plan,
                          levelTitle: e.target.value,
                        });
                    }}
                    
                    value={get(plan, "levelTitle")}
                    />
              </Col>
           </Row>
        )}
        {type !== "Lesson" && (
        <Row gutter={[24, 24]} style={{ marginTop: 10 }}>
              <Col span={24}>
                    <TextField
                      id="pageId"
                      name="pageId"
                      label="PageId"
                      disabled
                      InputLabelProps={{ shrink: true, required: true }}
                      type="number"
                      variant="outlined"
                      onChange={(e) => {

                      }}
                      value={pageId}
                    />
              </Col>
           </Row>
        )}
        
        {type !== "Super Lesson" && type !== "Differentiation" && (
          <Row
            gutter={[24, 24]}
            style={{ marginTop: 20, marginRight: 0, marginLeft: 0 }}
            className="floatingLabelBG"
          >
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="bookId">Book</InputLabel>
              <Autocomplete
                id="bookId"
                options={type === 'Assessment book link' ? booksAllListAssignment : booksAllList}
                getOptionLabel={(option) => `${option.description || ""} (${option.id || ""})`}
                value={booksAllList.find((bk) => bk.id === get(plan, "resourceId")) || null}
                onChange={(event, newValue) => {
                  setError(false);
                  setPlan({
                    ...plan,
                    resourceId: newValue ? newValue.id : "",
                    from: '',
                    to: '',
                  });
                  setSelectedLinkBook(newValue?.pages || []);
                }}
                renderInput={(params) => (
                  <TextField 
                    {...params} 
                    label="Book" 
                    variant="outlined"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        padding: '0px'
                      },
                      '& .MuiOutlinedInput-input': {
                        padding: '14px 14px'
                      }
                    }}
                  />
                )}
              />
            </FormControl>
          </Row>
        )}
        {type === 'Assessment book link' ? (
          <Row
            gutter={[24, 24]}
            style={{ marginTop: 20, marginRight: 0, marginLeft: 0 }}
            className="floatingLabelBG"
          >
            <FormControl variant="outlined" style={{ minWidth: 200 }}>
              <InputLabel id="fromPageLabel">To Page</InputLabel>
              <Select
                labelId="fromPageLabel"
                id="fromPage"
                value={parseInt(get(plan, "from"))}
                onChange={(e) => {
                  setError(false)
                  setPlan({
                    ...plan,
                    from: e.target.value,
                  });
                }}
                label="From Page"
              >
                {map(selectedLinkBook, (bk, index) => (
                  <MenuItem key={index} value={bk.pageId}>
                    {bk?.pageId}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Row>
        ) : (
          <Row gutter={[24, 24]} style={{ marginTop: 20 }}>
           <Col span={24}>
            <Autocomplete
              id="from-page-autocomplete"
              options={Array.isArray(selectedLinkBook) ? selectedLinkBook : []}
              getOptionLabel={(option) => option.NumberMasked || option.pageId || ''}
              value={Array.isArray(selectedLinkBook) ? selectedLinkBook.find(page => page.pageId == get(plan, "from")) || null : null}
              onChange={(event, newValue) => {
                setError(false)
                setPlan({
                  ...plan,
                  from: newValue?.pageId || '',
                  to: '',
                });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="From Page"
                  variant="outlined"
                  fullWidth
                  InputLabelProps={{ shrink: true, required: true }}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: <>{params.InputProps.endAdornment}</>,
                  }}
                />
              )}
              renderOption={(props, option) => <li {...props}>{option.NumberMasked || option.pageId}</li>}
              freeSolo={false}
              clearOnEscape
              selectOnFocus
              handleHomeEndKeys
            />
          </Col>
        </Row>
        )}
        {type !== 'Assessment book link' && (
          <Row gutter={[24, 24]} style={{ marginTop: 20 }}>
            <Col span={24}>
              <Autocomplete
                id="to-page-autocomplete"
                options={(() => {
                  if (!plan?.from || !selectedLinkBook || !Array.isArray(selectedLinkBook)) return [];
                  const fromPageId = parseInt(plan.from);
                  const startIndex = selectedLinkBook.findIndex(page => page.pageId == fromPageId);
                  if (startIndex === -1) return [];
                  const limitedPages = type === 'Super Lesson' || type === 'Differentiation' 
                    ? selectedLinkBook.slice(startIndex, startIndex + 10)
                    : selectedLinkBook.slice(startIndex);
                  return limitedPages;
                })()}
                getOptionLabel={(option) => option.NumberMasked || option.pageId || ''}
                value={(() => {
                  if (!plan?.to || !selectedLinkBook || !Array.isArray(selectedLinkBook)) return null;
                  return selectedLinkBook.find(page => page.pageId == get(plan, "to")) || null;
                })()}
                onChange={(event, newValue) => {
                  setError(false)
                  setPlan({
                    ...plan,
                    to: newValue?.pageId || '',
                  });
                }}
                disabled={!plan?.from}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="To Page"
                    variant="outlined"
                    fullWidth
                    InputLabelProps={{ shrink: true, required: true }}
                    placeholder={!plan?.from ? "Please select 'From Page' first" : "Select ending page"}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: <>{params.InputProps.endAdornment}</>,
                    }}
                  />
                )}
                renderOption={(props, option) => <li {...props}>{option.NumberMasked || option.pageId}</li>}
                freeSolo={false}
                clearOnEscape
                selectOnFocus
                handleHomeEndKeys
              />
            </Col>
          </Row>
        )}
      </LinkArea>
      {error ? (
        <FormHelperText error style={{width:"400px"}}>
          {errorMsg}
        </FormHelperText>
      ) : null}
      {type === 'Assessment book link' && booksAllListAssignment?.length === 0 && (
        <FormHelperText error>
          {"The book is empty please mark any book as main"}
        </FormHelperText>
      )}
      <Row
        gutter={[24, 24]}
        style={{ marginTop: 20, marginRight: 0, marginLeft: 0 }}
      >
        <Button
          fullWidth
          disabled={disableBtn()}
          onClick={onUpdate}
          color="primary"
          variant="contained"
        >
          Update
        </Button>
      </Row>
    </ModalConfigArea>
  </ModalContent>)
}


const PageDescriptionAndTags = ({ pgDescription , pgTags , onChangeOrUpdateDescription , pageId, hasPermission = true }) => {
  const [openModal, setOpenModal] = useState(false)
  const [description, setDescription] = useState('')
  const [pageTags, setPageTags] = useState('')
  const [loader, setLoader] = useState(false)
  useEffect(() => {
    setDescription(pgDescription)
    setPageTags(pgTags)
  }, [pgDescription, pgTags])
  const onUpdate = async() => {
    if(onChangeOrUpdateDescription){
      setLoader(true)
      await onChangeOrUpdateDescription({
        description,
        tags: pageTags,
        pageId
      })
      setLoader(false)
      setOpenModal(false)
    }
   }
  return (<>
    <BadgeButton
      onClick={() => {
        if (!hasPermission) {
          message.warning('You do not have permission to access this feature.');
          return;
        }
        setOpenModal(true);
      }}
      startIcon={<Add />}
      showBadge={pgDescription && pgTags}
      backgroundColor="#4f46e5"
    >
      Description and Tags
    </BadgeButton>
    <Modal
      open={openModal}
      onClose={() => setOpenModal(false)}
      style={{ height: "100%", width: "100%" }}
    >
      <ModalContent>
        <Row style={{ justifyContent: "space-between" }}>
          <TitleText>Description and Tags</TitleText>
          <IconButton
            onClick={()=>setOpenModal(false)}
            style={{ padding: 0 }}
          >
            <Close color="secondary" />
          </IconButton>
        </Row>
        <ModalConfigArea>
          <LinkArea>
            <Row gutter={[24, 24]} style={{ marginTop: 20 }}>
              <Col span={24}>
                <TextField
                  id="description"
                  name="description"
                  label="Description"
                  multiline
                  InputLabelProps={{ shrink: true, required: true }}
                  variant="outlined"
                  onChange={(e) => {
                    setDescription(e.target.value.trimStart());
                  }}
                  value={description}
                />
              </Col>
            </Row>
            <Row gutter={[24, 24]} style={{ marginTop: 20 }}>
              <Col span={24}>
                <Autocomplete
                  multiple
                  freeSolo
                  id="tags-outlined"
                  options={[]}
                  value={pageTags && pageTags.length > 0 ? pageTags.split(",") : []}
                  style={{ width: "100%" }}
                  onChange={(event, value) => {
                    const filteredTags = value.map(tag => tag.trim()).filter(tag => {
                      const t_txt = tag.trim()
                      return t_txt.length > 0
                    });
                    setPageTags(filteredTags.join(","))
                  }}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        label={option}
                        {...getTagProps({ index })}
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      type="text"
                      label="Tags"
                      placeholder="Tags"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          padding: '0px'
                        },
                        '& .MuiOutlinedInput-input': {
                          padding: '14px 14px'
                        }
                      }}
                    />
                  )}

                />
                <Typography variant="subtitle2" style={{ fontWeight:"lighter" , fontSize:"12px "}} >Note: press enter to add tags</Typography>
              </Col>

            </Row>
          </LinkArea>
          <Row
            gutter={[24, 24]}
            style={{ marginTop: 20, marginRight: 0, marginLeft: 0 }}
          >
            <Button
              fullWidth
              onClick={onUpdate}
              color="primary"
              variant="contained"
            >
              Update
            </Button>
          </Row>
        </ModalConfigArea>
      </ModalContent>
    </Modal>
  </>)
}
const PagePrintable = ({ pgPrintable, onChangePagePrintableOption, pageId  , is_book_printable}) => {
  const classes = useStyles();
  return (<FormControlLabel
    classes={{
      root: classes.rootDifFull,
      label: classes.label,
    }}
    onClick={e => {
      const target = e.target;
      if (!(target instanceof Element) || !target.closest('.MuiSwitch-root')) {
        e.preventDefault();
        e.stopPropagation();
      }
    }}
    control={
      <Switch
        classes={{
          sizeSmall: classes.sizeSmall,
          checked: classes.checkedSwitch
        }}
        checked={Boolean(pgPrintable)}
        id="Printable"
        onChange={e => {
          onChangePagePrintableOption(e.target.checked, pageId)
        }}
        name="Printable"
        color="primary"
        size="small"
      />
    }
    label={`Page printable`}
      // ${is_book_printable?`(Marked as All)`:''}`}
  />)
}
export default function PageToolbar({
  pageId,
  numberMask,
  onMaskChange,
  hyperlinks,
  teacherPage,
  pacingTeacherPage,
  syllabusTeacherPage,
  pagesPDF,
  pagePDF,
  onChangePDF,
  onRemovePDF,
  teacherEdition,
  onChangeHyperlink,
  onChangeAnswerPage,
  onChangePacing,
  onChangeSyllabus,
  onChangeAnswerDesc,
  onChangePacingAnswerDesc,
  onChangeSyllabusAnswerDesc,
  onCHangeTeacherEdition,
  onCHangeTeacherEditionDesc,
  pgEngage,
  onChangeEngage,
  onRemoveEngage,
  onRemoveAnsPage,
  onRemovePacingAnsPage,
  onRemoveSyllabusAnsPage,
  onRemoveTeacherEdition,
  pgLessonPlan,
  pgSuperLesson,
  pgDifferentiation,
  pgSentenceStarter,
  pgAssignmentPlan,
  pgWorkbookPlan,
  pgAssignmentBookLinkPlan,
  pgRubricsPlan,
  onChangeRunricsPlan,
  onRemoveRubricsPlan,
  booksAllList,
  onChangeAssignmentPlan,
  onChangeUnitExamPlan,
  onChangeLessionPlan,
  onChangeSuperLesson,
  onChangeDifferentiationLesson,
  onRemoveLessionPlan,
  onRemoveSuperLesson,
  onRemoveDifferentiationLesson,
  onRemoveAssignmentPlan,
  onRemoveUnitExamPlan,
  subTopics,
  pageActivities,
  pageQuizzes,
  onPageIdChange,
  page,
  bookId,
  onUpdateSubTopics,
  pageTips,
  pageIntrections,
  bookIdVoc,
  game_ai_content,
  onChangeGameAiContent,
  pages,
  onChangeWorkbookPlan,
  onChangeAssignmentBookLinkPlan,
  onRemoveWorkbookPlan,
  onRemoveAssignmentBookLinkPlan,
  onChangeMainBook,
  onRemoveMainbookPlan,
  pgMainbook,
  pgDescription,
  pgTags,
  onChangeOrUpdateDescription,
  onChangePagePrintableOption,
  pgPrintable,
  is_book_printable,
  updateLoader,
  setUpdateLoader,
  loaderImg,
  setLoaderImg,
  setdataloader,
  pgUnitExamPlan,
  main_book_data ={},
  onChangeSentenceStarter= () => {},
  onRemoveSentenceStarter=() => {},
  setSubTopics,
  onAdminAssignmentRefetch = () => {},
  onBulkMaskGenerate,
}) {
  const dispatch = useDispatch();
  const { firestore } = useFirebase();
  const { fetchDraftActivities, createBlankDraftDoc, createOrUpdateDraftDoc } = useCollectionActivity();
  const currentClass = useCurrentClass()
  const bookVocabulary = useVocabulary();
  const bookPhrases = usePhrases();
  const bookCognets = useCognets();
  const currentUser = useCurrentUser()
  const { logBookToolActivity } = useAdminActivityLogger();
  
  const hasUnits = useHasPermission('book_tools.units');
  const hasShowAnswers = useHasPermission('book_tools.show_answers');
  const hasTeacherEdition = useHasPermission('book_tools.teacher_edition');
  const hasHyperlinks = useHasPermission('book_tools.hyperlinks');
  const hasLessonPlan = useHasPermission('book_tools.lesson_plan');
  const hasSentenceStarter = useHasPermission('book_tools.sentence_starter');
  const hasSuperLesson = useHasPermission('book_tools.super_lesson');
  const hasDifferentiation = useHasPermission('book_tools.differentiation');
  const hasQuiz = useHasPermission('book_tools.quiz');
  const hasUnitExam = useHasPermission('book_tools.unit_exam');
  const hasWorkbook = useHasPermission('book_tools.workbook');
  const hasAssessmentBook = useHasPermission('book_tools.assessment_book');
  const hasAssessmentBookLink = useHasPermission('book_tools.assessment_book_link');
  const hasRubrics = useHasPermission('book_tools.rubrics');
  const hasTeacherStrategies = useHasPermission('book_tools.teacher_strategies');
  const hasInteractions = useHasPermission('book_tools.interactions');
  const hasAssignment = useHasPermission('book_tools.assignment');
  const hasVocabulary = useHasPermission('book_tools.vocabulary');
  const hasDescriptionTags = useHasPermission('book_tools.description_tags');
  const hasEnSp = useHasPermission('book_tools.en_sp');
  const hasGrammarAiActivity = useHasPermission('book_tools.grammar_ai_activity');
  const hasVocabAiActivity = useHasPermission('book_tools.vocab_ai_activity');
  const hasSlides = useHasPermission('book_tools.slides');
  const hasArticleLevels = useHasPermission('book_tools.article_levels');
  const hasGraphicOrganizers = useHasPermission('book_tools.graphic_organizers');
  const hasPdfUploader = useHasPermission('book_tools.pdf_uploader');
  const hasPacingGuide = useHasPermission('book_tools.pacing_guide');
  const hasSyllabus = useHasPermission('book_tools.syllabus');
  const has1Game = useHasPermission('book_tools.1game');
  const has1Study = useHasPermission('book_tools.1study');
  const hasExtensionActivities = useHasPermission('book_tools.extension_activities');
  
  const [hyperLinkDrawer, setHyperlinkDrawer] = useState(false);
  const [assignmentPlanDrawer, setAssignmentPlanDrawer] = useState(false);
  const [workbookPlanDrawer, setWorkbookPlanDrawer] = useState(false);
  const [bookLinkDrawer, setBookLinkDrawer] = useState(false)
  const [mainbookPlanDrawer, setmainbookPlanDrawer] = useState(false);

  const [superLessionDrawer, setSuperLessionDrawer] = useState(false);
  const [differentiationLessonDrawer, setDifferentiationLessonDrawer] = useState(false);
  const [unitQuizDrawer,setUnitQuizDrawer] = useState(false);
  const [rubricsPlanDrawer, setRubricsPlanDrawer] = useState(false);
  const [answerPageDrawer, setAnswerpageDrawer] = useState(false);
  const [teacherEditionPageDrawer, setTeacherEditionDrawer] = useState(false);
  const [activityDrawer, setActivityDrawer] = useState(false);
  const [assignmentBuilderOpen, setAssignmentBuilderOpen] = useState(false);
  const [quizDrawer, setQuizDrawer] = useState(false);
  const [unitsDrawer, setUnitsDrawer] = useState(false);
  const [pageid, setpageid] = useState(pageId);
  const [maskValue, setMaskValue] = useState(numberMask);
  const [isEditingMask, setIsEditingMask] = useState(false);
  const [generateMaskOpen, setGenerateMaskOpen] = useState(false);
  const [tipModal, setTipModal] = useState(false)
  const [intrectionModal, setintrectionModal] = useState(false)
  const [openVocabulary, setVocabulary] = useState(false);
  const [vocabularyPage, setVocabularyPage] = useState(true)
  const [vocabularyMy, setVocabularyMy] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false)
  const [deleteVocab, setDeleteVocab] = useState({});
  const [showAdd, setShowAdd] = useState(false)
  const [showPhraseAdd, setShowPhraseAdd] = useState(false)
  const [addVocabData, setAddVocabData] = useState({});
  const [addPhraseData, setAddPhraseData] = useState({});
  const [datas, setDatas] = useState({});
   const showAlert = useAlert();
  const [deleteVoc, setDeleteVoc] = useState(false);
  const [isEdited, setIsEdited] = useState(-1);
  const [aiModal, setAiModal] = useState(false);
  const [getBooksVocab, setGetBooksVocab] = useState({});
  const [getBooksPhrases, setGetBooksPhrases] = useState([]);
  const [vocabularyAI, setVocabularyAI] = useState();
  const [phraseAI, setPhraseAI] = useState();
  const [showWordLoader, setShowWordLoader] = useState(false)
  const [newItem, setNewItem] = useState({ isEditable: true });
  const [ai_content_modal, setAiContentModal] = useState(false);
  const allBooks = useAllBook()
  const book = useMemo(() => find(allBooks ?? [], ['id', bookId]), [allBooks, bookId]);
  const isFrench = book?.language === 'french';
  const fieldKey = isFrench ? 'synonyms_in_french' : 'synonyms_in_spanish';
  const antonymsFieldKey = isFrench ? 'antonyms_in_french' : 'antonyms_in_spanish';
  const sentenceFieldKey = isFrench ? 'sentence_in_french' : 'sentence_in_spanish';
  const readerLanguage = isFrench ? 'fr-FR' : 'es-ES';
  // Draft
  const [draftId, setDraftId] = useState(null);
  const [draftActivities, setDraftActivities] = useState([]);
  const [activityDrawerInitialData, setActivityDrawerInitialData] = useState(null);
  const examBooks = useExams();
  const standard_exams = useStandardExams();
  const storyBooks = useStory();

  
  // 1Game and 1Study
  const [aiModals, setAiModals] = useState(false);
  const [studyModals, setStudyModals] = useState(false);
  const [generationLoader, setGenerationLoader] = useState(false);
  const cognateRequestIdRef = useRef(0);

  // for story
  const storyBook = find(storyBooks, ["bookId", bookId]) || {};
  const isStoryBook  = Object.entries(storyBook)?.length > 0;
  const apExamBook = useApExams(); 
  
  //check if book is in main book collection
  const {getAllMainBookIds} = useBookCollection();
  const checkMainBookId = useMemo(() => {
    if(getAllMainBookIds && bookId){
      return getAllMainBookIds?.includes(bookId);
    }
  }, [getAllMainBookIds, bookId]);

  const is_non_roman = useMemo(() => {
    return isNaN(numberMask);
  }, [numberMask]);

  const checkApExamBookType = useMemo(() => {
    try{
      const exists = apExamBook.some(item =>
        item.exam_config.some(config => config.chapter === bookId)
      );
      return exists
    }catch(error){
      console.log(error);
    }
  },[apExamBook,bookId])

  const checkExamBookType = useMemo(() => {
    try {
      // Check in examBooks
      if (examBooks?.length > 0) {
        for (const level of examBooks) {
          for (const exam of level.exams) {
            if (Number(exam.bookId) === Number(bookId)) {
              return true;
            }
          }
        }
      }
      // Check in standard_exams
      if (standard_exams?.length > 0) {
        for (const item of standard_exams) {
          if (item.standard_exams?.some(config => config.bookId === bookId)) {
            return true;
          }
        }
      }
    } catch (error) {
      Sentry.captureException(`checkExamOrStandardExamBookType Error: ${error}`);
      console.log(error);
    }
    return false;
  }, [examBooks, standard_exams, bookId]);

  const is_non_spanish = useMemo(() => main_book_data?.book_type === 'non_native_spanish' || false, [main_book_data]);
  const [selected_mode, setSelectedMode] = useState('english_to_spanish');
  const [tabSelector, setTabSelector] = useState({type: "page_vocab"});
  const { stopAudio } = useAudio();
  const assignmentBuilderData = useMemo(() => ({ content: Array.isArray(pages) ? pages : [] }), [pages]);

  useEffect(() => {
    const filteredVocab = filter(bookVocabulary, obj => obj.chapter == bookId && obj.page == pageId);
    // const sorted_obj = sortBy(filteredVocab, (o) => {
    //   if (o.created_by === 'teacher') {
    //     return 0;
    //   } else {
    //     return 1;
    //   }
    // });
    setGetBooksVocab(uniqBy(filteredVocab, 'id'))
    // onFilterVocabulary();
  }, [bookVocabulary, pageId, bookId])


  useEffect(() => {
    const filteredPhrases = filter(bookPhrases, obj => obj.chapter == bookId && obj.page == pageId);
    setGetBooksPhrases(filteredPhrases)
  }, [bookPhrases, pageId, bookId])

  useEffect(() => {  
    if (bookId && bookId !== 'undefined' && pageId && pageId !== 'undefined') {
      getDraftData();
    }
  }, [firestore, draftId, bookId, pageId]);

  useEffect(() => {
    setDraftActivities([]);
  }, [pageId]);

  useEffect(() => {
    setMaskValue(numberMask);
  }, [numberMask]);

  const checkDuplicateMask = (newMaskValue) => {
    if (!pages || pages.length === 0) return false;
    
    const existingPage = find(pages, (p) => 
      String(p.NumberMasked).toLowerCase() === String(newMaskValue).toLowerCase() && 
      p.pageId !== pageId
    );
    
    if (existingPage) {
      setAlertSakeBar({
        open: true,
        message: `NumberMasked "${newMaskValue}" already exists on page ${existingPage.pageId}. Please use a different mask number.`,
        severity: "error",
      });
      setMaskValue(numberMask);
      return true;
    }
    return false;
  };

  const getDraftData = async () => {
    try {
      const fetchDraftData = await fetchDraftActivities(bookId, pageId, 'assignment');
      const draftsWithContent = fetchDraftData.filter((d) => assignmentDraftHasUserContent(d));
      setDraftActivities(prev => draftsWithContent.map(fetched => {
        const existing = prev.find(p => p.docId === fetched.docId);
        if (existing && (existing.displayName || (existing.questions?.length > 0)) && !fetched.displayName && (!fetched.questions || fetched.questions.length === 0)) {
          return existing;
        }
        return fetched;
      }));
    } catch (error) {
      console.error("Failed to fetch draft activities:", error);
    }
  };

  const createBlankDraft = async () => {
    const draftData = {
      id: '',
      bookId: bookId,
      chapter: bookId,
      displayName: '',
      page: pageId,
      typeId: 'activity',
      questions: [],
      colorCode: '',
      bookDescription: null,
      redirectTo: null,
      level: '',
      type: '',
      createdBy: null,
      cloneId: null,
      category: '',
      linked_to: [],
      share_list: null,
      share_by: null,
      language_feedback: '',
      activity_type: 'assignment',
      input_position: null,
      assignment_page: null,
      assignment_level: null,
      copy_of: {
        id: '',
        title: '',
      },
      is_exam: false,
      is_ai: null,
      is_unit_exam: false,
      unit: '',
      unit_exam: '',
      ai_grading_config: {},
      rubrics_id: '',
      storyInstruction: null,
      order_id: '',
      article_level_id: null,
      sequence_order: null,
      config_assignment: {},
    };

    try {
      const result = await createBlankDraftDoc(draftData);
      const newDraftId = result && (typeof result === 'object' && result !== null && 'docId' in result ? result.docId : result);
      let initialData = null;
      if (newDraftId) {
        initialData = { ...draftData, docId: newDraftId, questions: draftData.questions || [] };
      }
      return { draftId: newDraftId, initialData };
    } catch (e) {
      console.error('Error creating blank draft:', e);
      return { draftId: null, initialData: null };
    }
  };

  const createUnitBlankDraft = async () => {
    const draftData = {
      id: '',
      bookId,
      chapter: bookId,
      page: pageId,
      subTopics: [],
      activity_type: 'book_unit',
    };

    try {
      const newDraftId = await createOrUpdateDraftDoc(draftData);
      return newDraftId;
    } catch (e) {
      console.error('Error creating blank draft:', e);
      return null;
    }
  };

  const onFilterVocabulary = () => {
    let sorted_obj = sortBy(bookVocabulary,
      [
        function (o) {
          // Ensuring the property exists and is a string
          if (o.data && typeof o.data.word === 'string') {
            // Converting to lowercase for case-insensitive comparison
            return o.data.word.toLowerCase();
          }
          return ''; // Default value in case the property doesn't exist
        }
      ]);
    return sorted_obj;
  }
  const onFilterPhrasesStd = () => {
    let sorted_obj = sortBy(bookPhrases,
      [
        function (o) {
          if (o.data && typeof o.data.phrase === 'string') {
            return o.data.phrase.toLowerCase();
          }
          return '';
        }
      ]);
    return sorted_obj;
  }


  const inputRef = useRef(null);

  const [alertSakeBar, setAlertSakeBar] = useState({
    open: false,
    message: "",
    severity: "error",
  });
  const classes = useStyles();
  const unitScrollRef = useRef();
  const onCloseDrawer = () => {
    setHyperlinkDrawer(false);
    setAnswerpageDrawer(false);
    setTeacherEditionDrawer(false);

    setSuperLessionDrawer(false);
    setDifferentiationLessonDrawer(false);
    setAssignmentPlanDrawer(false);
    setWorkbookPlanDrawer(false);
    setBookLinkDrawer(false);
    setmainbookPlanDrawer(false)
    setRubricsPlanDrawer(false)
    setUnitsDrawer(false);
    setAiContentModal(false);
    setUnitQuizDrawer(false);
  };
  useEffect(() => {
    setpageid(pageId);
  }, [pageId]);

  const closeAlert = () => {
    setAlertSakeBar({ open: false, message: "", severity: "error" });
  };
  const onCreateOrUpdate = () => {
    setActivityDrawer(false);
    setQuizDrawer(false);
  };
  const teacherAnswerPageUpload = (item) => {
    if (item.url && item.url.includes("https")) {
      onChangeAnswerPage(item);
      // onCloseDrawer();
    }
  };
    const teacherEditionUpload = (item,selectedType) => {
      onCHangeTeacherEdition(item,selectedType);
      onCloseDrawer();
  };

  const handleOnChangeEngage = (item) => {
    onChangeEngage(item);
    onCloseDrawer();
};

  const teacherAnswerPacingUpload = (item) => {
    if (item.url && item.url.includes("https")) {
      onChangePacing(item);
      // onCloseDrawer();
    }
  };
  const teacherAnswerSyllabusUpload = (item) => {
    if (item.url && item.url.includes("https")) {
      onChangeSyllabus(item);
    }
  };
  const handleVocabulary = () => {
    setVocabulary(true)
    if (bookPhrases.length === 0) {
      dispatch(handleListPhrases(bookId, pageId, currentUser));
    }
  }
  const handleVocabularyClose = () => {
    cognateRequestIdRef.current += 1;
    setAiModal(false);
    setGenerationLoader(false);
    setVocabulary(false)
    setVocabularyAI({})
    setAddPhraseData({})
    setShowPhraseAdd(false)
    const dataToSend = getBooksVocab.filter(item => !item.isEditable);
    const phraseDataToSend = getBooksPhrases.filter(item => !item.isEditable);
    setGetBooksVocab(dataToSend)
    setGetBooksPhrases(phraseDataToSend)
    dispatch(setDataPhrases(onFilterPhrasesStd()))
    dispatch(setDataVocabular(onFilterVocabulary()))
  }

  const handleVocabularyPage = () => {
    setVocabularyPage(true)
    setVocabularyMy(false)
  }
  const handleVocabularyMy = () => {
    setVocabularyPage(false)
    setVocabularyMy(true)
  }

  const onDeleteVocab = async () => {
    if (tabSelector?.type === "page_phrases") {
      await dispatch(handleDeletePhrases(deleteVocab?.id));
      logBookToolActivity('delete', 'phrase', bookId, pageId, {
        phraseId: deleteVocab?.id,
        phrase: deleteVocab?.data?.phrase,
        bookName: book?.name || book?.description || 'Unknown Book'
      });
    } else {
      await dispatch(handleDeleteVocabulary(deleteVocab?.id));
      logBookToolActivity('delete', 'vocabulary', bookId, pageId, {
        vocabularyId: deleteVocab?.id,
        word: deleteVocab?.data?.word,
        bookName: book?.name || book?.description || 'Unknown Book'
      });
    }
    setDeleteModal(false);
    setDeleteVoc(false);
  }

  const handleAddVocData = (key, value) => {
    if (key == 'word') {
      const v = addVocabData;
      addVocabData[key] = value;
      setAddVocabData(v);
    } else {
      const v = vocabularyAI;
      vocabularyAI[key] = value;
      setVocabularyAI(v);
    }
  }

  const countWords = (text) => {
    if (!text || text.trim() === '') return 0;
    return text.trim().split(/\s+/).length;
  };

  const validateWordLimit = (text, maxWords = 10) => {
    const wordCount = countWords(text);
    return wordCount <= maxWords;
  };

  const handleAddPhraseData = (key, value) => {
    if (key == 'phrase') {
      if (!validateWordLimit(value)) {
        const words = value.trim().split(/\s+/);
        const limitedValue = words.slice(0, 10).join(' ');
        setAddPhraseData({ ...addPhraseData, [key]: limitedValue });
        showAlert(`You can only enter up to 10 words in the phrase field`, 'error');
        return;
      }
      setAddPhraseData({ ...addPhraseData, [key]: value });
    } else {
      setPhraseAI({ ...phraseAI, [key]: value });
    }
  }

  const addVocabulary = (vocabData) => {
    const dataToAdd = vocabData ? vocabData : vocabularyAI
    const dataVocab = {
      book_id: bookId,
      page: pageId,
      chapter: bookId,
      created_by: currentUser?.role,
      user_id: get(currentUser, 'id', ''),

      data: {
        word: addVocabData.word,
        ...dataToAdd
      },
    };
    dispatch(handleCreateVocabulary(dataVocab));
    logBookToolActivity('create', 'vocabulary', bookId, pageId, {
      word: addVocabData.word,
      bookName: book?.name || book?.description || 'Unknown Book'
    });
    setAddVocabData({})
    setVocabularyAI({})
    setShowAdd(false);
    setAlertSakeBar({
      open: true,
      message: "Created Successfully",
      severity: "success",
    })
  }

  const handleVocData = (key, value) => {
    const v = datas;
    datas[key] = value;
    setDatas(v);
  }

  // const handleUpdateData = async (data) => {
  //   const dataVocab = {
  //     book_id: bookId,
  //     page: pageId,
  //     chapter: bookId,
  //     created_by: currentUser?.role,
  //     user_id: get(currentUser, 'id', ''),
  //     class_id: get(currentClass, 'id', ''),
  //     data: {
  //       ...datas
  //     },
  //     id: data
  //   }
  //   dispatch(handleCreateVocabulary(dataVocab));

  // }
  const handleUpdateData = async (data) => {
    let datas = getBooksVocab.find(item => item.id === data?.id);
    await dispatch(handleCreateVocabulary(datas));
    logBookToolActivity('update', 'vocabulary', bookId, pageId, {
      vocabularyId: data?.id,
      word: datas?.data?.word,
      bookName: book?.name || book?.description || 'Unknown Book'
    });
    setAlertSakeBar({
      open: true,
      message: "Updated Successfully",
      severity: "success",
    })
  }

  function editDataProperty(targetId, newValue, propertyName) {
    const itemToEdit = getBooksVocab.find(item => item.id === targetId);
    const updatedData = getBooksVocab.map((item) =>
      item.id === targetId
        ? {
          ...item,
          data: {
            ...item.data,
            [propertyName]: newValue,
          },
        }
        : item
    );
    if (itemToEdit) {
      if(typeof itemToEdit.data === 'undefined'){
        itemToEdit.data = {};
      }  
      itemToEdit.data[propertyName] = newValue;
    }
    setGetBooksVocab(updatedData)
  }

  const callVocAI = async (initalAttempt = 0, maxAttempts = 2) => {
    if (addVocabData?.word ) {
      setShowWordLoader(true);
      let result = null;
      if (is_non_spanish) {
        if(initalAttempt < maxAttempts){
          result = await dispatch(
            handleGenerateVocabularyWithMode({
              topic: addVocabData?.word,
              book_id: bookId,
              page: pageId,
              chapter: bookId,
              created_by: currentUser?.role,
              user_id: get(currentUser, "id", ""),
              class_id: get(currentClass, "id", ""),
              mode: selected_mode,
            })
          );
          if(!result.valid){
            showAlert('Some Fields are missing in the response. Trying one more attempt', 'error');
            await callVocAI(initalAttempt + 1, maxAttempts);
          }

        }else{
          showAlert('Please try with differnet word!', 'info');
        }
      } else {
        if(initalAttempt < maxAttempts){
          result = await dispatch(
            handleCreateVocabularyAI({
              topic: addVocabData?.word,
              book_id: bookId,
              page: pageId,
              chapter: bookId,
              created_by: currentUser?.role,
              user_id: get(currentUser, "id", ""),
              class_id: get(currentClass, "id", ""),
            })
          );
          if(!result.valid){
            showAlert('Some Fields are missing in the response. Trying one more attempt', 'error');
            await callVocAI(initalAttempt + 1, maxAttempts);
          }

        }else{
          showAlert('Please try with differnet word!', 'info');
        }
        
      }

      if (result?.valid) {
        // setVocabularyAI({});
        setShowAdd(false);
        setAlertSakeBar({
          open: true,
          message: "Created Successfully",
          severity: "success",
        });
      } 
      setShowWordLoader(false);
    }
  };

  const addNewItem = () => {
    const isEditableItemExists = getBooksVocab.some(item => item.isEditable);
    if (!isEditableItemExists) {
      const updatedData = [...getBooksVocab, newItem];
      setGetBooksVocab(updatedData);
    }
  };
  
  const addNewPhraseItem = () => {
    const isEditableItemExists = getBooksPhrases.some(item => item.isEditable);
    if (!isEditableItemExists) {
      setAddPhraseData({});
      setPhraseAI({});
      const updatedData = [...getBooksPhrases, newItem];
      setGetBooksPhrases(updatedData);
    }
  };

  const addPhrase = (phraseData) => {
    const dataToAdd = phraseData ? phraseData : phraseAI
    const dataPhrase = {
      book_id: bookId,
      page: pageId,
      chapter: bookId,
      created_by: currentUser?.role,
      user_id: get(currentUser, 'id', ''),
      class_id: get(currentClass, 'id', ''),
      data: {
        ...(is_non_spanish ? {
          word: addPhraseData.phrase
        } : {
          phrase: addPhraseData.phrase
        }),
        english_translation: addPhraseData.english_translation || '',
        ...(is_non_spanish ? {
          sentence_in_spanish: addPhraseData.sentence_in_spanish || '',
          sentence_in_english: addPhraseData.sentence_in_english || ''
        } : {
          sentence: addPhraseData.sentence || '',
          sentence_english: addPhraseData.sentence_english || ''
        }),
        ...dataToAdd
      },
    };
    dispatch(handleCreatePhrases(dataPhrase));
    logBookToolActivity('create', 'phrase', bookId, pageId, {
      phrase: addPhraseData.phrase,
      bookName: book?.name || book?.description || 'Unknown Book'
    });
    setAlertSakeBar({
      open: true,
      message: "Created Successfully",
      severity: "success",
    })
    if (dataToAdd) {
      setAddPhraseData({})
      setPhraseAI({})
      setShowPhraseAdd(false)
    }
  }

  const callPhraseAI = async () => {
    if (addPhraseData?.phrase) {
      setShowWordLoader(true);
      let result = null;
      if (is_non_spanish) {
        result = await dispatch(
          handleGeneratePhrasesWithMode({
            topic: addPhraseData?.phrase,
            book_id: bookId,
            page: pageId,
            chapter: bookId,
            created_by: currentUser?.role,
            user_id: get(currentUser, "id", ""),
            class_id: get(currentClass, "id", ""),
            mode: selected_mode,
          })
        );
      } else {
         result = await dispatch(
          handleGeneratePhrasesWithAI({
            topic: addPhraseData?.phrase,
            book_id: bookId,
            page: pageId,
            chapter: bookId,
            created_by: currentUser?.role,
            user_id: get(currentUser, "id", ""),
            class_id: get(currentClass, "id", ""),
          })
        );
      }

      if (result) {
        setShowPhraseAdd(false);
        setAlertSakeBar({
          open: true,
          message: "Created Successfully",
          severity: "success",
        });
      } else {
        setAlertSakeBar({
          open: true,
          message: "No Result Found",
          severity: "error",
        });
      }
      setShowWordLoader(false);
    }
  };

  const editPhraseDataProperty = (targetId, newValue, propertyName) => {
    if (propertyName === 'phrase' && !validateWordLimit(newValue)) {
      const words = newValue.trim().split(/\s+/);
      const limitedValue = words.slice(0, 10).join(' ');
      const itemToEdit = getBooksPhrases.find(item => item.id === targetId);
      const updatedData = getBooksPhrases.map((item) =>
        item.id === targetId
          ? {
            ...item,
            data: {
              ...item.data,
              [propertyName]: limitedValue,
            },
          }
          : item
      );
      if (itemToEdit) {
        itemToEdit.data = itemToEdit?.data || {};
        itemToEdit.data[propertyName] = limitedValue;
      }
      setGetBooksPhrases(updatedData);
      showAlert(`You can only enter up to 10 words in the phrase field`, 'error');
      return;
    }
    const itemToEdit = getBooksPhrases.find(item => item.id === targetId);
    const updatedData = getBooksPhrases.map((item) =>
      item.id === targetId
        ? {
          ...item,
          data: {
            ...item.data,
            [propertyName]: newValue,
          },
        }
        : item
    );
    if (itemToEdit) {
      itemToEdit.data = itemToEdit?.data || {};
      itemToEdit.data[propertyName] = newValue;
    }
    setGetBooksPhrases(updatedData)
  }

  const handleUpdatePhraseData = async (data) => {
    let datas = getBooksPhrases.find(item => item.id === data?.id);
    await dispatch(handleCreatePhrases(datas));
    logBookToolActivity('update', 'phrase', bookId, pageId, {
      phraseId: data?.id,
      phrase: datas?.data?.phrase,
      bookName: book?.name || book?.description || 'Unknown Book'
    });
    setAlertSakeBar({
      open: true,
      message: "Updated Successfully",
      severity: "success",
    })
  }
  



  const AddWord = ({ addNewItem, book }) => {
    const menu = {
        items: [
            {
                key: "english_to_spanish",
                label: <CustomMenuItem onClick={() => addNewItem("english_to_spanish")}>English to Spanish</CustomMenuItem>
            },
            {
                key: "spanish_to_english",
                label: <CustomMenuItem2 onClick={() => addNewItem("spanish_to_english")}>Spanish to English</CustomMenuItem2>
            },
        ]
    };
    const frenchMenu = {
        items: [
            {
                key: "english_to_french",
                label: <CustomMenuItem onClick={() => addNewItem("english_to_french")}>English to French</CustomMenuItem>
            },
            {
                key: "french_to_english",
                label: <CustomMenuItem2 onClick={() => addNewItem("french_to_english")}>French to English</CustomMenuItem2>
            }
        ]
    };

    return (
        <Dropdown menu={book?.language === 'french' ? frenchMenu : menu} trigger={['click']} placement="bottomLeft" overlayClassName="custom-dropdown-menu">
            <IconButton aria-label="add">
                <Add style={{ fontSize: '18px' }}/>
            </IconButton>
        </Dropdown>
    );
};

const AddPhrase = ({ addNewPhraseItem }) => {
    const menu = {
        items: [
            {
                key: "english_to_spanish",
                label: <CustomMenuItem onClick={() => addNewPhraseItem("english_to_spanish")}>English to Spanish</CustomMenuItem>
            },
            {
                key: "spanish_to_english",
                label: <CustomMenuItem2 onClick={() => addNewPhraseItem("spanish_to_english")}>Spanish to English</CustomMenuItem2>
            },
        ]
    };

    return (
        <Dropdown menu={menu} trigger={['click']} placement="bottomLeft" overlayClassName="custom-dropdown-menu">
            <IconButton aria-label="add">
                <Add style={{ fontSize: '18px' }}/>
            </IconButton>
        </Dropdown>
    );
};

const toogleChange = (value) => {
  setTabSelector({type :  value})
  if (value === "page_phrases" && bookPhrases.length === 0) {
    dispatch(handleListPhrases(bookId, pageId, currentUser));
  }
}

const checkGenerateFromAi = async () => {
  try {
      const filterVocab = bookCognets?.filter((obj) => obj.page == pageId);
      const filterByAdmin = filterVocab?.filter((data) => data?.created_by === "owe_admin") || [];
      const filterByTeacher = filterVocab?.filter((data) => data?.created_by === "teacher") || [];
      const data = [...filterByAdmin, ...filterByTeacher];

      const isShowAiAlert = data.some((data) => data.is_ai === true);

      const dataAi = {
          bookId,
          page: pageId,
          chapter: bookId,
          created_by: currentUser?.role,
          user_id: get(currentUser, 'id', ''),
          class_id: get(currentClass, 'id', '')
      };

      handleVocabularyClose();

      const proceedWithAI = async () => {
          const requestId = cognateRequestIdRef.current + 1;
          cognateRequestIdRef.current = requestId;
          setAiModal(true);
          let generatedCount = 0;
          setGenerationLoader(false);
          await handleStreamResponseForCognates({
            path: 'ai/generate-cognates-stream',
            body: dataAi,
            onFirstResponse: () => {
              if (cognateRequestIdRef.current !== requestId) return;
              setAiModal(false);
              handleVocabulary(true);
              toogleChange("congantes");
              setGenerationLoader(true);
            },
            onCognate: (cog) => {
              if (cognateRequestIdRef.current !== requestId) return;
              if (cog && cog.id) {
                dispatch(createVocabularySuccessCogantes(cog))
              }
              generatedCount++;
            },
            onDuplicate: (dup) => {
            },
            onDone: () => {
               if (cognateRequestIdRef.current !== requestId) return;
               if(generatedCount === 0){
                setAlertSakeBar({
                  open: true,
                  message: "This page doesn't contain any data.",
                  severity: 'error',
                });
              }
              setGenerationLoader(false);
            },
            onError: (err) => {
              if (cognateRequestIdRef.current !== requestId) return;
              setGenerationLoader(false);
              setAiModal(false);
              setAlertSakeBar({
                open: true,
                message: "Something went wrong, please try again later.",
                severity: 'error',
              });
              console.error('Error in AI stream:', err);
            }
          })
      };

      if (isShowAiAlert) {
          ConfirmModal.confirm({
              title: 'Confirm',
              content: `You've already generated contents on this page. Are you sure you want to regenerate them?`,
              okText: 'Continue',
              okButtonProps: {
                className: 'force-blue-button',
                style: {
                    backgroundColor: '#012B70 !important',
                    borderColor: '#012B70 !important',
                }
            },
            onOk: async (close) => {
              close();
              await proceedWithAI();
            }, // Call API on "OK"
              onCancel: () => {
                handleVocabulary(true)
                toogleChange("congantes");
              }, // Do nothing on cancel
          });
      } else {
          await proceedWithAI(); // Call API directly if no alert is needed
      }
  } catch (error) {
      Sentry.captureException(`293 Error in checkGenerateFromAi: ${error}`);
      console.log(error);
  }
};

  // const filteredQuizAndActivity = useMemo(()=> {
  //   const data = [...pageActivities, ...pageQuizzes, ...draftActivities];
  //   const filteredData = sortByCustomType(data);
  //   const sortedActivities = [...filteredData].sort((a, b) => {
  //     const seqA = parseInt(a.sequence_order) || 0;
  //     const seqB = parseInt(b.sequence_order) || 0;
  //     return seqA - seqB;
  //   });
  //   return sortedActivities;
  // },[pageActivities, pageQuizzes, draftActivities])/

  const filteredQuizAndActivity = useMemo(() => {
    const data = [...pageActivities, ...pageQuizzes, ...draftActivities];

    // Deduplicate based on id — prefer draft: true
    const dedupedMap = new Map();
    for (const item of data) {
      const key = item.id || item.docId; // fallback to docId if id is blank
      const existing = dedupedMap.get(key);
      if (!existing || item.draft) {
        dedupedMap.set(key, item);
      }
    }
    
    const dedupedData = Array.from(dedupedMap.values());

    const filteredData = sortByCustomType(dedupedData);

    const sortedActivities = [...filteredData].sort((a, b) => {
      const seqA = parseInt(a.sequence_order) || 0;
      const seqB = parseInt(b.sequence_order) || 0;
      return seqA - seqB;
    });

    const filterNonEngageMent = sortedActivities.filter(activity => activity?.config_assignment?.isFrom !== "engagement");
    return filterNonEngageMent;
  }, [pageActivities, pageQuizzes, draftActivities]);

  const filteredQuizAndActivityEngagement = useMemo(() => {
    const data = [...pageActivities, ...pageQuizzes, ...draftActivities];

    // Deduplicate based on id — prefer draft: true
    const dedupedMap = new Map();
    for (const item of data) {
      const existing = dedupedMap.get(item.id);
      if (!existing || item.draft) {
        dedupedMap.set(item.id, item);
      }
    }
    const dedupedData = Array.from(dedupedMap.values());

    const filteredData = sortByCustomType(dedupedData);

    const sortedActivities = [...filteredData].sort((a, b) => {
      const seqA = parseInt(a.sequence_order) || 0;
      const seqB = parseInt(b.sequence_order) || 0;
      return seqA - seqB;
    });

    const filterNonEngageMent = sortedActivities.filter(activity => activity?.config_assignment?.isFrom === "engagement");
    return filterNonEngageMent;
  }, [pageActivities, pageQuizzes, draftActivities]);

  const checkEngageOptionAvailable = useMemo(() => {
    const page = parseInt(pageId);
    
    if (isNaN(page)) {
      return { exists: false, message: 'Invalid page number' };
    }

    const normalizedSubTopics = Array.isArray(subTopics) ? subTopics : [];
    if (normalizedSubTopics.length === 0) {
      return { exists: false, message: 'No sections available' };
    }

    const foundSection = normalizedSubTopics.find(section => {
      const start = parseInt(section.startPage);
      const end = parseInt(section.finishPage);
      return page >= start && page <= end;
    });

    if (foundSection) {
      return {
        exists: true,
        section: foundSection,
        message: `Page ${page} found in "${foundSection.description}" (${foundSection.shortName})`
      };
    }

    return {
      exists: false,
      message: `Page ${page} not found in any section`
    };
  }, [pageId, subTopics]);



  return (
    <SentryWrap>
      <Wrapper>
        <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={alertSakeBar.open}
        autoHideDuration={3000}
        onClose={closeAlert}
      >
        <Alert
          onClose={() => {
            setAlertSakeBar({ open: false, message: "", severity: "error" });
          }}
          severity={alertSakeBar.severity}
        >
          <strong>ALERT:</strong> {alertSakeBar.message}
        </Alert>
      </Snackbar>

      {/* Tips modal  */}

      <TipsModal
        data={pageTips}
        pageId={pageId}
        bookId={bookId}
        open={tipModal}
        close={() => setTipModal(false)}
        setAlertSakeBar={setAlertSakeBar}
      />
      <IntrectionModal
        data={pageIntrections}
        pageId={pageId}
        bookId={bookId}
        open={intrectionModal}
        close={() => setintrectionModal(false)}
        setAlertSakeBar={setAlertSakeBar}
        updateLoader={updateLoader}
        setUpdateLoader={setUpdateLoader}
        setdataloader={setdataloader}
      />

      {/* assignment plan */}
      <Modal
        open={assignmentPlanDrawer}
        onClose={() => onCloseDrawer()}
        style={{ height: "100%", width: "100%" }}
      >
        <AssignmentPlanModal
          planData={pgAssignmentPlan}
          onRemoveAssignmentPlan={id => {
            onRemoveAssignmentPlan(id)
            onCloseDrawer()
          }}
          pageId={pageId}
          booksAllList={booksAllList}
          close={() => onCloseDrawer()}
          updatePlan={data => {
            onChangeAssignmentPlan(data)
            onCloseDrawer()
          }}
          type={"Quiz"}
          totalPages={pages?.length}
          pages={pages}
        />
      </Modal>

       {/* Unit Quiz */}
       <Modal
        open={unitQuizDrawer}
        onClose={() => onCloseDrawer()}
        style={{ height: "100%", width: "100%" }}
      >
        <AssignmentPlanModal
          planData={pgUnitExamPlan}
          onRemoveAssignmentPlan={id => {
            onRemoveUnitExamPlan(id)
            onCloseDrawer()
          }}
          pageId={pageId}
          booksAllList={booksAllList}
          close={() => onCloseDrawer()}
          updatePlan={data => {
            onChangeUnitExamPlan(data)
            onCloseDrawer()
          }}
          type={"Unit Exam"}
          totalPages={pages?.length}
          pages={pages}
        />
      </Modal>
      
      {/* workbook plan */}
      <Modal
        open={workbookPlanDrawer}
        onClose={() => onCloseDrawer()}
        style={{ height: "100%", width: "100%" }}
      >
        <AssignmentPlanModal
          planData={pgWorkbookPlan}
          onRemoveAssignmentPlan={id => {
            onRemoveWorkbookPlan(id)
            onCloseDrawer()
          }}
          pageId={pageId}
          booksAllList={booksAllList}
          close={() => onCloseDrawer()}
          updatePlan={data => {
            onChangeWorkbookPlan(data)
            onCloseDrawer()
          }}
          type={"workbook"}
          totalPages={pages?.length}
          pages={pages}
        />
      </Modal>

      {/* Assessment book link plan */}
      <Modal
        open={bookLinkDrawer}
        onClose={() => onCloseDrawer()}
        style={{ height: "100%", width: "100%" }}
      >
        <AssignmentPlanModal
          planData={pgAssignmentBookLinkPlan}
          onRemoveAssignmentPlan={id => {
            onRemoveAssignmentBookLinkPlan(id)
            onCloseDrawer()
          }}
          pageId={pageId}
          booksAllList={booksAllList}
          close={() => onCloseDrawer()}
          updatePlan={data => {
            onChangeAssignmentBookLinkPlan(data)
            onCloseDrawer()
          }}
          bookId={bookId}
          type={"Assessment book link"}
          totalPages={pages?.length}
          pages={pages}
        />
      </Modal>

      {/* main book  */}
      <Modal
        open={mainbookPlanDrawer}
        onClose={() => onCloseDrawer()}
        style={{ height: "100%", width: "100%" }}
      >
        <AssignmentPlanModal
          planData={pgMainbook}
          onRemoveAssignmentPlan={id => {
            onRemoveMainbookPlan(id)
            onCloseDrawer()
          }}
          pageId={pageId}
          booksAllList={booksAllList}
          close={() => onCloseDrawer()}
          updatePlan={data => {
            onChangeMainBook(data)
            onCloseDrawer()
          }}
          type={"Assessment book"}
          totalPages={pages?.length}
          pages={pages}
        />
      </Modal>


      {/* Super Lesson */}
      <Modal
        open={superLessionDrawer}
        onClose={() => onCloseDrawer()}
        style={{ height: "100%", width: "100%" }}
      >
        <AssignmentPlanModal
          planData={pgSuperLesson}
          onRemoveAssignmentPlan={id => {
            onRemoveSuperLesson(id)
            onCloseDrawer()
          }}
          pageId={pageId}
          bookId={bookId}
          booksAllList={booksAllList}
          close={() => onCloseDrawer()}
          updatePlan={data => {
            onChangeSuperLesson(data)
            onCloseDrawer()
          }}
          type={"Super Lesson"}
          totalPages={pages?.length}
          pages={pages}
        />
      </Modal>

      {/* differentiation Lesson */}
      <Modal
        open={differentiationLessonDrawer}
        onClose={() => onCloseDrawer()}
        style={{ height: "100%", width: "100%" }}
      >
        <AssignmentPlanModal
          planData={pgDifferentiation}
          onRemoveAssignmentPlan={id => {
            onRemoveDifferentiationLesson(id)
            onCloseDrawer()
          }}
          bookId={bookId}
          pageId={pageId}
          booksAllList={booksAllList}
          close={() => onCloseDrawer()}
          updatePlan={data => {
            onChangeDifferentiationLesson(data)
            onCloseDrawer()
          }}
          type={"Differentiation"}
          totalPages={pages?.length}
          pages={pages}
        />
      </Modal>

      {/* Rubrics plan */}
      <Modal
        open={rubricsPlanDrawer}
        onClose={() => onCloseDrawer()}
        style={{ height: "100%", width: "100%" }}
      >
        <AssignmentPlanModal
          planData={pgRubricsPlan}
          onRemoveAssignmentPlan={id => {
            onRemoveRubricsPlan(id)
            onCloseDrawer()
          }}
          pageId={pageId}
          booksAllList={booksAllList}
          close={() => onCloseDrawer()}
          updatePlan={data => {
            onChangeRunricsPlan(data)
            onCloseDrawer()
          }}
          type={"Rubrics"}
          totalPages={pages?.length}
          pages={pages}
        />
      </Modal>

      {/* rubrics plan end */}
      {/*-- units plan--- */}
     {unitsDrawer && <Modal
        open={unitsDrawer}
        onClose={() => onCloseDrawer()}
        style={{ height: "100%", width: "100%" }}
      >
        <SubTopicUnits
          draftId={draftId}
          data={subTopics}
          pages={pages}
          setDraftId={setDraftId}
          onCloseDrawer={onCloseDrawer}
          onUpdateUnits={onUpdateSubTopics}
        />
      </Modal>}


      {/* hyper link config */}
      <Modal
        open={hyperLinkDrawer}
        onClose={() => onCloseDrawer()}
        style={{ height: "100%", width: "100%" }}
      >
        <ModalContent>
          <Row style={{ justifyContent: "space-between" }}>
            <TitleText>HyperLinks</TitleText>
            <IconButton
              onClick={() => onCloseDrawer()}
              style={{ padding: 0 }}
            >
              <Close color="secondary" />
            </IconButton>
          </Row>

          <HyperLinkForm
            hyperlinks={hyperlinks}
            pageId={pageId}
            onChangeHyperlink={(data) => {
              onCloseDrawer();
              onChangeHyperlink(data);
            }}
          />
        </ModalContent>
      </Modal>
{/* Ai content modal */}
      <Modal
        open={ai_content_modal}
        onClose={() => onCloseDrawer()}
        style={{ height: "100%", width: "100%" }}
      >
        <ModalFullContent>
          <Row style={{ justifyContent: "space-between" }}>
            <TitleText>Game AI content.</TitleText>
            <IconButton
              onClick={() => onCloseDrawer()}
              style={{ padding: 0 }}
            >
              <Close color="secondary" />
            </IconButton>
          </Row>

          {ai_content_modal ? <GameAiForm
            ai_content={game_ai_content}
            pageId={pageId}
            pages={pages}
            onChangeGameAiContent={(data) => {
              onCloseDrawer();
              onChangeGameAiContent(data);
            }}
          /> : null}
        </ModalFullContent>
      </Modal>
      {/* answer page drawer */}
      <Modal
        open={answerPageDrawer}
        onClose={() => { }}
        style={{ height: "100%", width: "100%" }}
      >
        <AnswerModal
          data={teacherPage}
          onChangeDesc={onChangeAnswerDesc}
          onChangeImage={teacherAnswerPageUpload}
          onCloseDrawer={onCloseDrawer}
          title={`Answer Page`}
          pageId={pageId}
          onRemove={onRemoveAnsPage}
          updateLoader={updateLoader}
          setUpdateLoader={setUpdateLoader}
          loaderImg={loaderImg}
          setLoaderImg={setLoaderImg}
        />
      </Modal>


      {/* Start of Vocabulary Modal */}
      
         <DeleteModal deleteToggle={deleteModal} loading={deleteVoc} onDelete={() => {
        onDeleteVocab();
        setDeleteVoc(true);
      }}
        setDeleteToggle={setDeleteModal}
        message={`Are you sure you want to remove this "${deleteVocab?.data?.word || deleteVocab?.data?.phrase || 'item'}" ${tabSelector?.type === "page_phrases" ? 'phrase' : 'vocabulary'}?`} />
      <CognateAiLoader aiModal={aiModal} />
      <Modal className='vocabulModal' open={openVocabulary} onClose={handleVocabularyClose}
        style={{ height: '100%', width: '100%', backgroundColor: "transparent" }}>
        <ModalContents is_non_spanish={is_non_spanish} className='vocabulContent'>
          <Close color="secondary" onClick={handleVocabularyClose} className='vocabulClose' />
          <div className='VocabularyTab FirstVocabularyTab flex items-stretch gap-5px flex-wrap mr-26px'>
            <Button
              className={`minWith ${tabSelector?.type === "page_vocab" ? 'selected selected-background-color' : ''}`}
              onClick={() => toogleChange("page_vocab")}
            >
              Page Vocabulary
            </Button>

            <Button
              className={`minWith ${tabSelector?.type === "page_phrases" ? 'selected selected-background-color' : ''}`}
              onClick={() => toogleChange("page_phrases")}
            >
              Page Phrases
            </Button>

            <Button
              className={`minWith ${tabSelector?.type === "congantes" ? 'selected selected-background-color' : ''}`}
              onClick={() => toogleChange("congantes")}
            >
              Cognates
            </Button>

              {tabSelector?.type === "congantes" && <Button className='create-with-ai-button minWith' onClick={() => {
                logBookToolActivity('create', 'cognates_ai', bookId, pageId);
                checkGenerateFromAi();
              }}>Cognates with AI</Button>}
          </div>
          <div className='vocabulTableUpr vocab-table-upar vocInMobile vocabStrokeWidth' style={{ maxHeight: 550, overflowY: 'scroll' }}>
            {tabSelector?.type === "congantes" && (
              <Cogantes tabSelector={tabSelector} bookId={bookId} pageId={pageId} non_native={is_non_spanish} />
            )}
            
            {tabSelector?.type === "page_phrases" &&
              <table border="1" className='vocabulTable'>
                <tr className='vocabulHeadTh'>
                  {is_non_spanish ? (
                    <>
                        <th>Phrase</th>
                        <th>Translation</th>
                        <th>Sentence in Spanish</th>
                        <th>Sentence in English</th>
                        <th>Actions</th>
                    </>
                  ) : (
                    <>
                  <th>Phrase</th>
                  <th>Translation</th>
                  <th>Sentence in Spanish</th>
                  <th>Sentence in English</th>
                  <th>Actions</th>
                    </>
                  )}
                </tr>
                {map(getBooksPhrases, (value,index) => {
                  const data = get(value, 'data', '');
                  const mode = data?.mode || "";
                  if (value?.created_by == 'student') return;
          
                  return (
                    <tr className='vocabulHeadTr vocIcons' key={index}>
                      <td style={{ minWidth: 150, maxWidth: 250 }}>
                        {value?.isEditable ? (
                          <div style={{ position: 'relative' }}>
                            <InputArea
                              value={addPhraseData.phrase || ''}
                              onPressEnter={() => {
                                if (!showWordLoader) {
                                  callPhraseAI();
                                }
                              }}
                              onChange={(d) => { handleAddPhraseData('phrase', d.target.value.trimStart()) }}
                              placeholder='phrase'
                              autoSize
                              autoFocus
                              style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200 }}
                            />
                            <div style={{ position: 'absolute', top: 6, right: 4 }}>
                              {showWordLoader ? <Loading size={17} /> : <EnterOutlined disabled={showWordLoader} onClick={() => {
                                if (!showWordLoader) {
                                  callPhraseAI();
                                }
                              }} style={{ fontSize: '25px' }} />}
                            </div>
                          </div>
                        ) : (
                          <>
                            <TextReader stopAudio={stopAudio} text={get(data, is_non_spanish ? 'word' : 'phrase', '')} language={mode === 'english_to_spanish' ? "en-US" : mode === 'spanish_to_english' ? "es-ES" : "es-ES"} style={{ float: "right" }} />
                            <InputArea
                              disabled={value?.created_by === 'owe_admin'}
                              value={get(data, is_non_spanish ? 'word' : 'phrase', '') + (value?.created_by === 'owe_admin' ? ' (Admin)' : '')}
                              onChange={(d) => editPhraseDataProperty(value.id, d.target.value.trimStart(), is_non_spanish ? 'word' : 'phrase')}
                              placeholder='phrase'
                              autoSize
                              style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200 }}
                            />
                          </>
                        )}
                      </td>
                      <td>
                        {value?.isEditable ? (
                          <TextArea
                            value={get(data, 'english_translation', '')}
                            onChange={(d) => { handleAddPhraseData('english_translation', d.target.value.trimStart()) }}
                            autoSize
                            style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                          />
                        ) : (
                          <>
                            <TextReader stopAudio={stopAudio} text={get(data, 'english_translation', '')} language={mode === 'english_to_spanish' ? "es-ES" : mode === 'spanish_to_english' ? "en-US" : "en-US"} style={{ float: "right" }} />                        
                            <TextArea
                              onBlur={() => {
                                handleUpdatePhraseData(value)
                              }}
                              value={get(data, 'english_translation', '')}
                              onChange={(d) => editPhraseDataProperty(value.id, d.target.value.trimStart(), 'english_translation')}
                              autoSize
                              style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                            />
                          </>
                        )}
                      </td>
                      <td>
                        {value?.isEditable ? (
                          <TextArea
                            value={get(data, 'sentence', '')}
                            onChange={(d) => { handleAddPhraseData('sentence', d.target.value.trimStart()) }}
                            autoSize
                            style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                          />
                        ) : (
                          <>
                            <TextReader stopAudio={stopAudio} text={get(data, is_non_spanish ? 'sentence_in_spanish' : 'sentence', '')} language={mode === 'english_to_spanish' ? "es-ES" : mode === 'spanish_to_english' ? "es-ES" : "es-ES"} style={{ float: "right" }} />
                            <TextArea
                              onBlur={() => {
                                handleUpdatePhraseData(value)
                              }}
                              value={get(data, is_non_spanish ? 'sentence_in_spanish' : 'sentence', '')}
                              onChange={(d) => editPhraseDataProperty(value.id, d.target.value.trimStart(), is_non_spanish ? 'sentence_in_spanish' : 'sentence')}
                              autoSize
                              style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                            />
                          </>
                        )}
                      </td>
                      <td>
                        {value?.isEditable ? (
                          <TextArea
                            value={get(data, is_non_spanish ? 'sentence_in_english' : 'sentence_english', '')}
                            onChange={(d) => { handleAddPhraseData(is_non_spanish ? 'sentence_in_english' : 'sentence_english', d.target.value.trimStart()) }}
                            autoSize
                            style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                          />
                        ) : (
                          <>
                            <TextReader stopAudio={stopAudio} text={get(data, is_non_spanish ? 'sentence_in_english' : 'sentence_english', '')} language={"en-US"} style={{ float: "right" }} />
                            <TextArea
                              onBlur={() => {
                                handleUpdatePhraseData(value)
                              }}
                              value={get(data, is_non_spanish ? 'sentence_in_english' : 'sentence_english', '')}
                              onChange={(d) => editPhraseDataProperty(value.id, d.target.value.trimStart(), is_non_spanish ? 'sentence_in_english' : 'sentence_english')}
                              autoSize
                              style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                            />
                          </>
                        )}
                      </td>
                      {value?.created_by !== 'student' ? (
                        <td style={{ textAlign: 'center' }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                              <Delete style={{ fontSize: '20px' }} onClick={() => {
                                setDeleteModal(true);
                                setDeleteVocab(value);
                              }} />
                            </div>
                        </td>
                      ) : (
                        <td style={{ textAlign: 'center' }}>
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <ActionText>Student</ActionText>
                          </div>
                        </td>
                      )}
                    </tr>
                  )
                })}
                {showPhraseAdd && (
                  <tr className='vocabulHeadTr vocIcons'>
                    <td>
                      <TextArea
                        disabled={!phraseAI || phraseAI?.phrase === undefined}
                        onChange={(e) => {
                          e.preventDefault()
                          setPhraseAI({ ...phraseAI, phrase: e.target.value })
                        }}
                        value={get(phraseAI, "phrase", "")}
                        autoSize
                        style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                      />
                    </td>
                    <td>
                      <TextArea
                        disabled={!phraseAI || phraseAI?.english_translation === undefined}
                        onChange={(e) => {
                          e.preventDefault()
                          setPhraseAI({ ...phraseAI, english_translation: e.target.value })
                        }}
                        value={phraseAI?.english_translation}
                        autoSize
                        style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                      />
                    </td>
                    <td>
                      <TextArea
                        disabled={!phraseAI || phraseAI?.sentence === undefined}
                        onChange={(e) => {
                          e.preventDefault()
                          setPhraseAI({ ...phraseAI, sentence: e.target.value })
                        }}
                        value={phraseAI?.sentence}
                        autoSize
                        style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                      />
                    </td>
                    <td>
                      <TextArea
                        disabled={!phraseAI || phraseAI?.sentence_english === undefined}
                        onChange={(e) => {
                          e.preventDefault()
                          setPhraseAI({ ...phraseAI, sentence_english: e.target.value })
                        }}
                        value={phraseAI?.sentence_english}
                        autoSize
                        style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                      />
                    </td>
                    <td>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      </div>
                    </td>
                  </tr>
                )}
                <tr className='vocabulHeadTr'>
                  {is_non_spanish ? (
                    <>
                      <td>
                        <IconButton>
                          <AddPhrase book={book} addNewPhraseItem={key => {
                            setSelectedMode(key)
                            addNewPhraseItem()
                          }} />
                        </IconButton>
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </>
                  ) : (
                    <>
                      <td>
                        <IconButton>
                          <Add style={{ fontSize: '18px' }} onClick={() => {
                            addNewPhraseItem()
                          }} />
                        </IconButton>
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </>
                  )}
                </tr>
              </table>
            }
            
            {vocabularyPage && tabSelector?.type === "page_vocab" &&
              <table border="1" className='vocabulTable'>
                <tr className='vocabulHeadTh'>
                  {is_non_spanish ? (
                    <>
                        <th>Word</th>
                        <th>Translation</th>
                        <th>Definition</th>
                        <th>{`Synonyms in ${book?.language === 'french' ? 'French' : 'Spanish'}`}</th>
                        <th>Synonyms in English</th>
                        <th>{`Antonyms in ${book?.language === 'french' ? 'French' : 'Spanish'}`}</th>
                        <th>Antonyms in English</th>
                        <th>{`Sentence in ${book?.language === 'french' ? 'French' : 'Spanish'}`}</th>
                        <th>Sentence in English</th>
                        <th>Actions</th>
                    </>
                  ) : (
                    <>
                  <th>Word</th>
                  <th>Definition</th>
                  <th>English translation</th>
                  <th>Synonyms</th>
                  <th>Antonyms</th>
                  <th>Sentence</th>
                  <th>Actions</th>
                    </>
                  )}
                 
                </tr>
                {map(getBooksVocab, (value,index) => {
                  const data = get(value, 'data', '');
                  const mode = data?.mode || "";
                  if (value?.created_by == 'student') return;
          
                  if(is_non_spanish){
                    return (
                      <tr className='vocabulHeadTr vocIcons' key={index}>
                        <td style={{ minWidth: 150, maxWidth: 250 }}>
                          {value?.isEditable == true ? (
                            <div style={{ position: 'relative' }}>
                              <InputArea
                                onPressEnter={() => {
                                  if (!showWordLoader) {
                                    callVocAI();
                                  }

                                }}
                                onChange={(d) => { handleAddVocData('word', d.target.value.trimStart()) }}
                                placeholder='word'
                                autoSize
                                autoFocus
                                style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200 }}
                              />
                              <div style={{ position: 'absolute', top: 6, right: 4 }}>
                                {showWordLoader ? <Loading size={17} /> : <EnterOutlined disabled={showWordLoader} onClick={() => {
                                  if (!showWordLoader) {
                                    callVocAI();
                                  }
                                }} style={{ fontSize: '25px' }} />}
                              </div>
                            </div>
                          ) : (<>
                            <TextReader stopAudio={stopAudio} text={get(data, 'word', '')} language={mode === 'english_to_spanish' ? "en-US" : mode === 'spanish_to_english' ? "es-ES" : mode === 'english_to_french' ? "en-US" : mode === 'french_to_english' ? "fr-FR" : "en-US"} style={{ float: "right" }} />
                            <InputArea
                              disabled={true}
                              value={`${get(data, 'word', '')} (${value?.created_by == 'owe_admin' ? 'Admin' : value?.created_by})`}
                              onChange={(d) => editDataProperty(value.id, d.target.value.trimStart(), 'word')}
                              placeholder='word'
                              autoSize
                              autoFocus
                              style={{ width: 150, backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200 }}
                            />

                          </>
                          )}
                        </td>
                        <td>
                        <TextReader stopAudio={stopAudio} text={get(data, 'english_translation', '')} language={mode === 'english_to_spanish' ? "es-ES" : mode === 'spanish_to_english' ? "en-US" : mode === 'english_to_french' ? "fr-FR" : mode === 'french_to_english' ? "en-US" : "en-US"} style={{ float: "right" }} />
                          <TextArea
                            onBlur={() => {
                              handleUpdateData(value)
                            }}
                            value={get(data, 'english_translation', '')}
                            onChange={(d) => editDataProperty(value.id, d.target.value.trimStart(), 'english_translation')}
                            autoSize
                            style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                          />

                        </td>
                        <td>
                        <TextReader stopAudio={stopAudio} text={get(data, 'definition', '')} language={"en-US"} style={{ float: "right" }} />
                          <TextArea
                            onBlur={() => {
                              handleUpdateData(value)
                            }}
                            value={get(data, 'definition', '')}
                            onChange={(d) => editDataProperty(value.id, d.target.value.trimStart(), 'definition')}
                            autoSize
                            style={{ width: 200, backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                          />

                        </td>
                        <td>
                        <TextReader stopAudio={stopAudio} text={get(data, fieldKey, '')} language={readerLanguage} style={{ float: "right" }} />
                                           
                          <TextArea
                            onBlur={() => {
                              handleUpdateData(value)
                            }}
                            value={get(data, fieldKey, '')}
                            onChange={(d) => editDataProperty(value.id, d.target.value.trimStart(), fieldKey)}
                            autoSize
                            style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                          />

                        </td>
                        <td>
                        <TextReader stopAudio={stopAudio} text={get(data, 'synonyms_in_english', '')} language={"en-US"} style={{ float: "right" }} />                                 
                          <TextArea
                            onBlur={() => {
                              handleUpdateData(value)
                            }}
                            value={get(data, 'synonyms_in_english', '')}
                            onChange={(d) => editDataProperty(value.id, d.target.value.trimStart(), 'synonyms_in_english')}
                            autoSize
                            style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                          />

                        </td>
                        <td>
                        <TextReader stopAudio={stopAudio} text={get(data, antonymsFieldKey, '')} language={readerLanguage} style={{ float: "right" }} />
                          <TextArea
                            onBlur={() => {
                              handleUpdateData(value)
                            }}
                            value={get(data, antonymsFieldKey, '')}
                            onChange={(d) => editDataProperty(value.id, d.target.value.trimStart(), antonymsFieldKey)}
                            autoSize
                            style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                          />

                        </td>
                        <td>
                        <TextReader stopAudio={stopAudio} text={get(data, 'antonyms_in_english', '')} language={"en-US"} style={{ float: "right" }} />
                                           
                          <TextArea
                            onBlur={() => {
                              handleUpdateData(value)
                            }}
                            value={get(data, 'antonyms_in_english', '')}
                            onChange={(d) => editDataProperty(value.id, d.target.value.trimStart(), 'antonyms_in_english')}
                            autoSize
                            style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                          />

                        </td>
                        <td>
                        <TextReader stopAudio={stopAudio} text={get(data, sentenceFieldKey, '')} language={readerLanguage} style={{ float: "right" }} />            
                          <TextArea
                            onBlur={() => {
                              handleUpdateData(value)
                            }}
                            value={get(data, sentenceFieldKey, '')}
                            onChange={(d) => editDataProperty(value.id, d.target.value.trimStart(), sentenceFieldKey)}
                            autoSize
                            style={{ width: 200, backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                          />

                        </td>
                        <td>
                        <TextReader stopAudio={stopAudio} text={get(data, 'sentence_in_english', '')} language={"en-US"} style={{ float: "right" }} />
                                            
                          <TextArea
                            onBlur={() => {
                              handleUpdateData(value)
                            }}
                            value={get(data, 'sentence_in_english', '')}
                            onChange={(d) => editDataProperty(value.id, d.target.value.trimStart(), 'sentence_in_english')}
                            autoSize
                            style={{ width: 200, backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                          />
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          {data?.word && (
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                              <Delete style={{ fontSize: '20px' }} onClick={() => {
                                setDeleteModal(true);
                                setDeleteVocab(value);
                              }} />
                            </div>
                          )}
                        </td>
                      </tr>
                  )
                  }else{
                    return (
                      <tr className='vocabulHeadTr vocIcons'>
                        <td>
                          {value?.isEditable == true ? (
                            <div style={{ position: 'relative' }}>
                              <InputArea
                                onPressEnter={() => {
                                  if (!showWordLoader) {
                                    callVocAI();
                                  }
                                }}
                                onChange={(d) => { handleAddVocData('word', d.target.value) }}
                                placeholder='word'
                                autoSize
                                style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200 }}
                              />
                              <div style={{ position: 'absolute', top: 6, right: 4 }}>
                                {showWordLoader ? <Loading size={17} /> : <EnterOutlined onClick={() => {
                                  callVocAI();
                                }} style={{ fontSize: '25px' }} />}
                              </div>
                            </div>
                          ) : (
                            <>
                                <TextReader stopAudio={stopAudio} text={get(data, 'word', '')} language={"es-ES"} style={{ float: "right" }} />
                                <InputArea
                                disabled={value?.created_by === 'owe_admin' || (currentUser?.role === 'student' || value?.created_by === 'teacher')}
                                value={`${get(data, 'word', '')} (${value?.created_by == 'owe_admin' ? 'Admin' : value?.created_by})`}
                                onChange={(d) => editDataProperty(value.id, d.target.value, 'word')}
                                placeholder='word'
                                autoSize
                                style={{ width: 150, backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200 }}
                              />
                            </>
                          )}
                        </td>
                        <td>
                        <TextReader stopAudio={stopAudio} text={get(data, 'definition', '')} language={"es-ES"} style={{ float: "right" }} />
                          <TextArea
                            onBlur={() => {
                              handleUpdateData(value)
                            }}
                            value={get(data, 'definition', '')}
                            onChange={(d) => editDataProperty(value.id, d.target.value, 'definition')}
                            autoSize
                            style={{ width: 200, backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                          />
                        </td>
                        <td>
                        <TextReader stopAudio={stopAudio} text={get(data, 'english_translation', '')} language={"en-US"} style={{ float: "right" }} />                        
                         <TextArea
                            onBlur={() => {
                              handleUpdateData(value)
                            }}
                            value={get(data, 'english_translation', '')}
                            onChange={(d) => editDataProperty(value.id, d.target.value, 'english_translation')}
                            autoSize
                            style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                          />
                        </td>
                        <td>
                        <TextReader stopAudio={stopAudio} text={get(data, 'synonyms', '')} language={"es-ES"} style={{ float: "right" }} />
                                              
                          <TextArea
                            onBlur={() => {
                              handleUpdateData(value)
                            }}
                            value={get(data, 'synonyms', '')}
                            onChange={(d) => editDataProperty(value.id, d.target.value, 'synonyms')}
                            autoSize
                            style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                          />
                        </td>
                        <td>
                        <TextReader stopAudio={stopAudio} text={get(data, 'antonyms', '')} language={"es-ES"} style={{ float: "right" }} />
                                               
                          <TextArea
                            onBlur={() => {
                              handleUpdateData(value)
                            }}
                            value={get(data, 'antonyms', '')}
                            onChange={(d) => editDataProperty(value.id, d.target.value, 'antonyms')}
                            autoSize
                            style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                          />
                        </td>
                        <td>
                        <TextReader stopAudio={stopAudio} text={get(data, 'sentence', '')} language={"es-ES"} style={{ float: "right" }} />
                                              
                          <TextArea
                            onBlur={() => {
                              handleUpdateData(value)
                            }}
                            value={get(data, 'sentence', '')}
                            onChange={(d) => editDataProperty(value.id, d.target.value, 'sentence')}
                            autoSize
                            style={{ width: 200, backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                          />
                        </td>
                        {value?.created_by !== 'student' ? (
                          <td style={{ textAlign: 'center' }}>
                            {data?.word && (
                              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Delete style={{ fontSize: '20px' }} onClick={() => {
                                  setDeleteModal(true);
                                  setDeleteVocab(value);
                                }} />
                              </div>
                            )}
                          </td>
                        )
                          :
                          <td style={{ textAlign: 'center' }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                              <ActionText>
                                Student
                              </ActionText>
                            </div>
                          </td>
                        }
                      </tr>
                    )
                  }

                 
                })}
                {showAdd && (
                  <tr className='vocabulHeadTr vocIcons'>
                    <td>
                      <TextArea
                        disabled={!vocabularyAI || vocabularyAI?.definition === undefined}
                        onChange={(e) => {
                          e.preventDefault()
                          setVocabularyAI({ ...vocabularyAI, definition: e.target.value })
                        }}
                        value={get(vocabularyAI, "definition", "")}

                        autoSize
                        style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}

                      />
                    </td>
                    <td>
                      <TextArea
                        disabled={!vocabularyAI || vocabularyAI?.english_translation === undefined}
                        onChange={(e) => {
                          e.preventDefault()
                          setVocabularyAI({ ...vocabularyAI, english_translation: e.target.value })
                        }}
                        value={vocabularyAI?.english_translation}
                        autoSize
                        style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                      />
                    </td>
                    <td>
                      <TextArea
                        disabled={!vocabularyAI || vocabularyAI?.synonyms === undefined}
                        onChange={(e) => {
                          e.preventDefault()
                          setVocabularyAI({ ...vocabularyAI, synonyms: e.target.value })
                        }}
                        value={vocabularyAI?.synonyms}

                        autoSize
                        style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                      />
                    </td>
                    <td>
                      <TextArea
                        disabled={!vocabularyAI || vocabularyAI?.sentence === undefined}
                        onChange={(e) => {
                          e.preventDefault()
                          setVocabularyAI({ ...vocabularyAI, sentence: e.target.value })
                        }}
                        value={vocabularyAI?.sentence}

                        autoSize
                        style={{ backgroundColor: 'transparent', borderColor: 'transparent', color: 'white', fontWeight: 200, padding: 0 }}
                      />
                    </td>
                    <td>

                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      </div>
                    </td>
                  </tr>
                )}
                <tr className='vocabulHeadTr'>
                {is_non_spanish ? (
                  <>
                  <td>
                  <IconButton>
                      <AddWord book={book} addNewItem={key => {
                          setSelectedMode(key)
                          addNewItem()
                      }} />
                    </IconButton>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  </>
                ):(
                  <>
                  <td>
                      <IconButton>
                    <Add style={{ fontSize: '18px' }} onClick={() => {
                      addNewItem()
                    }} />
                  </IconButton>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  </>
                )}
                </tr>
              </table>
            }
          </div>
        </ModalContents>
      </Modal>
      
     
      {/* End of Vocabulary Modal */}
      {/* Activites Drawer  */}
        {activityDrawer && (
          <AssignmentForm
            pageSrc={get(page, "resource")}
            bookId={bookId}
            pageId={pageId}
            data={activityDrawerInitialData}
            onCreateOrUpdate={onCreateOrUpdate}
            type={"activity"}
            draftId={draftId}
            setDraftId={setDraftId}
            open={activityDrawer}
            onClose={(savedDraft) => {
              if (savedDraft?.docId) {
                setDraftActivities(prev => {
                  const without = prev.filter(a => a.docId !== savedDraft.docId);
                  return [...without, savedDraft];
                });
              }
              setActivityDrawer(false);
              setActivityDrawerInitialData(null);
              setDraftId(null);
              getDraftData();
            }}
          />
        )}
        {assignmentBuilderOpen && (
          <AssignmentBuilderTool
            open={assignmentBuilderOpen}
            onClose={() => setAssignmentBuilderOpen(false)}
            data={assignmentBuilderData}
            page={pageId}
            chapter={bookId}
            from="ebook"
            pageSrc={get(page, "resource")}
            pageTitle={get(page, "NumberMasked")}
            disableSubmit={false}
            generatedTest
            onCreated={() => {
              if (typeof onAdminAssignmentRefetch === 'function') {
                onAdminAssignmentRefetch();
              }
            }}
          />
        )}



        {quizDrawer && (
          <AssignmentForm
            pageId={pageId}
            pageSrc={get(page, "resource")}
            data={null}
            bookId={bookId}
            onCreateOrUpdate={onCreateOrUpdate}
            type={"quiz"}
            open={quizDrawer}
            onClose={() => {
              setQuizDrawer(false);
            }}
          />
        )}


      <Toolbar>
        {/* <Page>
          PageId:{" "}
          <Input
            style={{ boder: "none" }}
            type="text"
            value={pageid}
            onChange={(e) => {
              setpageid(e.target.value);
            }}
            onSubmit={(e) => {
              onPageIdChange(pageid);
            }}
            onBlur={(e) => {
              onPageIdChange(e.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                onPageIdChange(pageid);
              }
            }}
          />
        </Page> */}
        <Page>
          NumberMasked :{" "}
          {!isEditingMask ? (
            <>
              <span style={{ fontWeight: '500', margin: '0 8px' }}>{numberMask}</span>
              <EditOutlined 
                style={{ color: "black", cursor: 'pointer' }} 
                onClick={() => setIsEditingMask(true)}
              />
            </>
          ) : (
            <Input
              type="text"
              value={maskValue}
              autoFocus
              style={{ width: '100px', margin: '0 8px' }}
              onChange={(e) => setMaskValue(e.target.value)}
              onBlur={(e) => {
                const isDuplicate = checkDuplicateMask(e.target.value);
                if (!isDuplicate) {
                  onMaskChange(e.target.value);
                }
                setIsEditingMask(false);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  const isDuplicate = checkDuplicateMask(maskValue);
                  if (!isDuplicate) {
                    const oldMask = numberMask;
                    onMaskChange(maskValue);
                  }
                  setIsEditingMask(false);
                }
              }}
            />
          )}
          {" "} 
          <Tooltip
            title={
              <p style={{ margin: 0 }}>
                Note - NumberMasked is for edit purpose do not use for navigation
              </p>
            }
          >
            <InfoCircleOutlined style={{ color: "black", marginLeft: '10px' }} />
          </Tooltip>
          {typeof onBulkMaskGenerate === 'function' && pages?.length > 0 ? (
            <Button
              variant="outlined"
              size="small"
              sx={{ ml: 2 }}
              onClick={() => setGenerateMaskOpen(true)}
            >
              Generate mask
            </Button>
          ) : null}
        </Page>
      </Toolbar>
      {typeof onBulkMaskGenerate === 'function' ? (
        <GenerateMaskModal
          open={generateMaskOpen}
          onClose={() => setGenerateMaskOpen(false)}
          totalPages={pages?.length || 0}
          pages={pages}
          onGenerate={onBulkMaskGenerate}
        />
      ) : null}
      <Row 
        className='buttonListAddon'
        style={{ marginTop: 10, display: "flex", justifyContent: "flex-start" }}
      >
        {checkEngageOptionAvailable?.exists  && (checkExamBookType || checkMainBookId)  ? (
                     <ToolBarEngageMentAdmin 
                     getDraftData={getDraftData} 
                     page={page} 
                     pageSrc={get(page, "resource")} 
                     filteredQuizAndActivityEngagement={filteredQuizAndActivityEngagement}
                     pgEngage={pgEngage} 
                     onRemoveEngage={onRemoveEngage} 
                     createBlankDraft={createBlankDraft}
                     onChangeEngage={handleOnChangeEngage} bookId={bookId} pageId={pageId} subTopics={subTopics} />
        ) : null}
        <BadgeButton
          onClick={async() => {
            if (!hasUnits) {
              message.warning('You do not have permission to access this feature.');
              return;
            }
            //const newDraftId = await createUnitBlankDraft();
            //if (newDraftId) {
              //setDraftId(newDraftId?.docId ? newDraftId?.docId : newDraftId);
             // setSubTopics(newDraftId?.subTopics?.length > 0 ? newDraftId?.subTopics : subTopics);
              //logBookToolActivity('create', 'units', bookId, pageId, {
              //  unitId: newDraftId?.docId ? newDraftId?.docId : newDraftId
              //});
            //}
            setSubTopics(subTopics || []);
            setUnitsDrawer(true);
          }}
          startIcon={<MenuBook />}
          showBadge={false}
          backgroundColor="#5a67d8"
        >
          Units
        </BadgeButton>
        <BadgeButton
          onClick={() => {
            if (!hasShowAnswers) {
              message.warning('You do not have permission to access this feature.');
              return;
            }
            setAnswerpageDrawer(true);
          }}
          startIcon={<QuestionAnswer />}
          showBadge={teacherPage?.length > 0}
          backgroundColor="#2c5282"
        >
          Show answers
        </BadgeButton>
        <TeacherEditionModal
          data={teacherEdition}
          onChangeDesc={onCHangeTeacherEditionDesc}
          onChangeImage={teacherEditionUpload}
          onCloseDrawer={onCloseDrawer}
          title={`Teacher edition Page`}
          pageId={pageId}
          onRemove={onRemoveTeacherEdition}
          booksAllList={booksAllList}
          bookId={bookId}
          hasPermission={hasTeacherEdition}
        />
        <BadgeButton
          onClick={() => {
            if (!hasHyperlinks) {
              message.warning('You do not have permission to access this feature.');
              return;
            }
            setHyperlinkDrawer(true);
          }}
          startIcon={<Link />}
          showBadge={hyperlinks}
          backgroundColor="#c53030"
        >
          Hyperlinks
        </BadgeButton>
        <LessonPlanModal
          planData={pgLessonPlan}
          onRemoveAssignmentPlan={id => {
            onRemoveLessionPlan(id)
          }}
          pageId={pageId}
          booksAllList={booksAllList}
          updatePlan={data => {
            onChangeLessionPlan(data)
          }}
          bookId={bookId}
          totalPages={pages?.length}
          pages={pages}
          hasPermission={hasLessonPlan}
        />
        <ToolBarSentenceStarterButton 
          planData={pgSentenceStarter}
          pageId={pageId} 
          updatePlan={data => {
              onChangeSentenceStarter(data)
              onCloseDrawer()
          }}
          booksAllList={booksAllList} 
          filterOrdersByOrderIds={filterOrdersByOrderIds} 
          bookId={bookId}
          onRemoveAssignmentPlan={id => {
            onRemoveSentenceStarter(id)
            onCloseDrawer()
        }}
        totalPages={pages?.length}
        pages={pages} 
        hasPermission={hasSentenceStarter}
        />
        {(checkExamBookType || checkApExamBookType) ? null : <ExtraResourceAdmin pageId={pageId} bookId={bookId} hasPermission={hasExtensionActivities} />}

        <BadgeButton
          onClick={() => {
            if (!hasSuperLesson) {
              message.warning('You do not have permission to access this feature.');
              return;
            }
            setSuperLessionDrawer(true);
          }}
          startIcon={<Star />}
          showBadge={pgSuperLesson}
          backgroundColor="#d69e2e"
        >
          Super Lesson
        </BadgeButton>
        <BadgeButton
          onClick={() => {
            if (!hasDifferentiation) {
              message.warning('You do not have permission to access this feature.');
              return;
            }
            setDifferentiationLessonDrawer(true);
          }}
          startIcon={<Tune />}
          showBadge={pgDifferentiation}
          backgroundColor="#38a169"
        >
          Differentiation
        </BadgeButton>
        <BadgeButton
          onClick={() => {
            if (!hasQuiz) {
              message.warning('You do not have permission to access this feature.');
              return;
            }
            setAssignmentPlanDrawer(true);
          }}
          startIcon={<Quiz />}
          showBadge={pgAssignmentPlan}
          backgroundColor="#3182ce"
        >
          Quiz
        </BadgeButton>
        <BadgeButton
          onClick={() => {
            if (!hasUnitExam) {
              message.warning('You do not have permission to access this feature.');
              return;
            }
            setUnitQuizDrawer(true);
          }}
          startIcon={<Grading />}
          showBadge={pgUnitExamPlan}
          backgroundColor="#2f855a"
        >
          Unit Exam
        </BadgeButton>
        <BadgeButton
          onClick={() => {
            if (!hasWorkbook) {
              message.warning('You do not have permission to access this feature.');
              return;
            }
            setWorkbookPlanDrawer(true);
          }}
          startIcon={<Book />}
          showBadge={pgWorkbookPlan}
          backgroundColor="#dd6b20"
        >
          Workbook
        </BadgeButton>
        <BadgeButton
          onClick={() => {
            if (!hasAssessmentBook) {
              message.warning('You do not have permission to access this feature.');
              return;
            }
            setmainbookPlanDrawer(true);
          }}
          startIcon={<LibraryBooks />}
          showBadge={pgMainbook}
          backgroundColor="#553c9a"
        >
          Assessment book
        </BadgeButton>
        <BadgeButton
          onClick={() => {
            if (!hasAssessmentBookLink) {
              message.warning('You do not have permission to access this feature.');
              return;
            }
            setBookLinkDrawer(true);
          }}
          startIcon={<InsertLink />}
          showBadge={pgAssignmentBookLinkPlan}
          backgroundColor="#7c3aed"
        >
          Assessment book link
        </BadgeButton>
        <BadgeButton
          onClick={() => {
            if (!hasRubrics) {
              message.warning('You do not have permission to access this feature.');
              return;
            }
            setRubricsPlanDrawer(true);
          }}
          startIcon={<Assessment />}
          showBadge={pgRubricsPlan}
          backgroundColor="#be185d"
        >
          Rubrics
        </BadgeButton>
        <BadgeButton
          onClick={() => {
            if (!hasTeacherStrategies) {
              message.warning('You do not have permission to access this feature.');
              return;
            }
            setTipModal(true);
          }}
          startIcon={<Lightbulb />}
          showBadge={pageTips}
          backgroundColor="#b7791f"
        >
          Teacher strategies
        </BadgeButton>
        <BadgeButton
          onClick={() => {
            if (!hasInteractions) {
              message.warning('You do not have permission to access this feature.');
              return;
            }
            setintrectionModal(true);
          }}
          startIcon={<TouchApp />}
          showBadge={pageIntrections && pageIntrections.length > 0}
          backgroundColor="#e53e3e"
        >
          Interactions
        </BadgeButton>
        <BadgeButton
          onClick={async() => {
            if (!hasAssignment) {
              message.warning('You do not have permission to access this feature.');
              return;
            }
            if (!bookId) {
              setAlertSakeBar({
                open: true,
                message: "Please create book first.",
                severity: "error",
              });
              return;
            }
            const result = await createBlankDraft();
            if (result?.draftId) {
              setDraftId(result.draftId);
              setActivityDrawerInitialData(result.initialData || null);
              logBookToolActivity('create', 'assignment', bookId, pageId, {
                draftId: result.draftId
              });
            }
            setActivityDrawer(true);
          }}
          startIcon={<Assignment />}
          showBadge={false}
          backgroundColor="#319795"
        >
          Assignment
        </BadgeButton>
        <BadgeButton
          onClick={() => {
            if (!hasVocabulary) {
              message.warning('You do not have permission to access this feature.');
              return;
            }
            handleVocabulary(true);
          }}
          startIcon={<Spellcheck />}
          showBadge={getBooksVocab.length > 0}
          backgroundColor="#2d7d32"
        >
          Vocabulary
        </BadgeButton>
        <SoyHistoriasAdmin page={pageId} chapter={bookId} main_book_data={main_book_data} />
        <PageDescriptionAndTags pgDescription={pgDescription} pgTags={pgTags} onChangeOrUpdateDescription={onChangeOrUpdateDescription} pageId={pageId} hasPermission={hasDescriptionTags} />
        {checkExamBookType ? null : <PageTranslationToolbar pageId={pageId}  bookId={bookId} hasPermission={hasEnSp} />}
        {checkExamBookType || is_non_roman ? null : <GrammarContentToolBar pageId={pageId}  bookId={bookId} hasPermission={hasGrammarAiActivity} />}
        {checkExamBookType || is_non_roman ? null : <VocabContentToolBar pageId={pageId}  bookId={bookId} pages={pages} hasPermission={hasVocabAiActivity} />}
        {checkExamBookType ? null : <AdminSlides  pageId={pageId}  bookId={bookId} book={main_book_data} hasPermission={hasSlides} />}
        {checkExamBookType ? null : <ArticleLevelToolBar bookId={bookId} pageId={pageId} pages={pages} hasPermission={hasArticleLevels} />}
        {checkExamBookType ? null : <GraphicOrganizerAdmin chapter={bookId} page={pageId} pages={pages} hasPermission={hasGraphicOrganizers} />}
        {(checkExamBookType || checkApExamBookType) ? null : <PDFUploader pageId={pageId} bookId={bookId} pdfData={pagesPDF} onChangePDF={onChangePDF} onRemovePDF={onRemovePDF} hasPermission={hasPdfUploader} />}
        {(checkExamBookType || isStoryBook) ? null : <PacingSyallabus pageId={pageId} chapter={bookId} teacherPage={pacingTeacherPage} onChangeAnswerDesc={onChangePacingAnswerDesc} teacherAnswerPageUpload={teacherAnswerPacingUpload} onCloseDrawer={onCloseDrawer} onRemoveAnsPage={onRemovePacingAnsPage} updateLoader={updateLoader} setUpdateLoader={setUpdateLoader} setLoaderImg={setLoaderImg} hasPermission={hasPacingGuide} />}
        {(checkExamBookType || isStoryBook) ? null : <Syallabus pageId={pageId} chapter={bookId} teacherPage={syllabusTeacherPage} onChangeAnswerDesc={onChangeSyllabusAnswerDesc} teacherAnswerPageUpload={teacherAnswerSyllabusUpload} onCloseDrawer={onCloseDrawer} onRemoveAnsPage={onRemoveSyllabusAnsPage} updateLoader={updateLoader} setUpdateLoader={setUpdateLoader} setLoaderImg={setLoaderImg} hasPermission={hasSyllabus} />}
        <PagePrintable pgPrintable={pgPrintable} onChangePagePrintableOption={onChangePagePrintableOption} pageId={pageId} is_book_printable={is_book_printable} />
        {checkExamBookType ? null : (
          <div className={`NwadminSideCollect gameStudyBtn ${currentUser?.role === 'owe_admin' ? 'adminSideCollect' : ''}`}>
              <BingoModal page={pageId} chapter={bookId} />
              <OnegameModals
                aiModal={aiModals}
                setAiModal={setAiModals}
                booksAllList={booksAllList}
                chapter={bookId}
                page={pageId}
                currentClass={currentClass}
                pages={pages}
                currentUser={currentUser}
                hasPermission={has1Game}
              />
              <OnestudyModals
                aiModal={studyModals}
                setAiModal={setStudyModals}
                booksAllList={booksAllList}
                chapter={bookId}
                page={pageId}
                currentClass={currentClass}
                pages={pages}
                currentUser={currentUser}
                hasPermission={has1Study}
              />
          </div>
        )}
        
        {/* <Button
          size="small"
          variant="contained"
          color="primary"
          style={{ margin: 2 }}
          onClick={() => {
            if (!bookId) {
              setAlertSakeBar({
                open: true,
                message: "Please create book first.",
                severity: "error",
              });
              return;
            }
            setQuizDrawer(true);
          }}
        >
          Quizzes
        </Button> */}
      </Row>
      {currentUser?.role === 'owe_admin' ? (
        <div className="vocOrGame" style={{ display: 'flex', width: '100%', gap: '9px', marginTop: 6 }}>
          <TestGenerator
            type="button"
            onClick={() => {
              if (!hasAssignment) {
                message.warning('You do not have permission to access this feature.');
                return;
              }
              if (!bookId) {
                setAlertSakeBar({
                  open: true,
                  message: "Please create book first.",
                  severity: "error",
                });
                return;
              }
              setAssignmentBuilderOpen(true);
            }}
            style={{ flex: 1 }}
            title="Assignment Builder"
          >
            <AssignmentOutlined sx={{ fontSize: 24, color: '#01989E' }} /> Generate Test
          </TestGenerator>
        </div>
      ) : null}
      <AssignmemntArea>
        <AdminActivity pageActivities={filteredQuizAndActivity} page={page} pageId={pageId} bookId={bookId} draftId={draftId} setDraftId={setDraftId} onDraftDeleted={getDraftData} onAdminAssignmentRefetch={onAdminAssignmentRefetch} onDraftSaved={(savedDraft) => {
          if (savedDraft?.docId) {
            setDraftActivities(prev => {
              const without = prev.filter(a => a.docId !== savedDraft.docId);
              return [...without, savedDraft];
            });
          }
        }} />
      </AssignmemntArea>
      </Wrapper>
    </SentryWrap>
  );
}